import React from 'react'
import consentAnimation from 'assets/animation/consent-animation.json';
import Lottie from "lottie-react";
import StyledAnimationWrapper from 'components/styled/AnimationWrapper.styled';
import StyledBackgroundWrapper from 'components/styled/BackgroundWrapper.styled';

const SvgConsentIntro = (props) => (
  <StyledBackgroundWrapper>
    <StyledAnimationWrapper top="0px" left="0" width="20%">
      <Lottie animationData={consentAnimation} loop={true} autoPlay={true} />
    </StyledAnimationWrapper>
    <StyledAnimationWrapper top="0" left="40%" width="30%">
      <Lottie animationData={consentAnimation} loop={true} autoPlay={true} />
    </StyledAnimationWrapper>
    <svg
    viewBox="0 0 1465 1055"
  >
    <defs>
      <pattern
        id="New_Pattern_Swatch_3"
        data-name="New Pattern Swatch 3"
        width={131}
        height={104}
        patternTransform="translate(-1805 -2612)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#fbaa2c" />
      </pattern>
      <pattern
        id="Unnamed_Pattern"
        data-name="Unnamed Pattern"
        width={131}
        height={104}
        patternTransform="translate(-1805 -2612)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#97459a" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_2"
        data-name="New Pattern Swatch 2"
        width={131}
        height={104}
        patternTransform="translate(-1805 -2612)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#a2ce46" />
      </pattern>
      <pattern
        id="New_Pattern_Swatch_4"
        data-name="New Pattern Swatch 4"
        width={131}
        height={104}
        patternTransform="translate(-1805 -2612)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#13a89e" />
      </pattern>
      <clipPath id="clip-path">
        <path
          d="M944.21,964.21c.92-9.16-1.44-19.22-3.12-20.09-5.48-1.88-25.75,9.17-29.83,30.52a6.18,6.18,0,0,0,.14,3.05c1.62,5,4.52,8.68,14.08,9.06h5c6.42,0,13.19-4.37,15-9.7h0a6.28,6.28,0,0,0,.3-3C945.42,971.27,943.88,967.56,944.21,964.21Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="New_Pattern_Swatch_8"
        data-name="New Pattern Swatch 8"
        width={131}
        height={104}
        patternTransform="translate(-1805 -2612)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#8d9092" />
      </pattern>
      <clipPath id="clip-path-2">
        <path
          d="M941.46,551.46s29.2-.57,41.09,4.72c42,18.7,64.09,55.2,69,78.86,3.62,17.4,9.79,52.77-7.82,87.42,0,0-9.25,3.37-28.05-5.87,0,0,10.45-33.58,5-66.32C1016,622.33,990,608.81,990,608.81c-3.1,11.29-.91,20,2.82,35.15a335.74,335.74,0,0,1,8,43c3.8,32.59,3.91,59.88-15.88,73,0,0-19.13-49.11-41.56-49.47,0,0,8.43-23,6.34-58.28C946.15,590.74,937.47,569.52,941.46,551.46Z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-3">
        <path
          d="M896.29,554.46s-17.15,6.18-25.92,14.88c-13,12.87-13.07,31.8-15.73,31.39,0,0-.07-10.51-5.18-15.79a41.73,41.73,0,0,0-10.11-.65c-6.42.44-13.34,4.19-13.34,4.19-6.41,20-2.65,80.46,23.12,81.43,22.29.85,32.51-41.86,32.51-41.86-.67,20-2.17,32.73-14.16,66.65-10.74,30.41-11.72,49.8-11.72,49.8,7.51,11.74,31,13.16,31,13.16,10.55-16,7.15-21.77,14.94-70.64,5.07-31.76,8.32-39.43,9.71-63.89C912.69,600.31,910,562.26,896.29,554.46Z"
          fill="none"
        />
      </clipPath>
      <pattern
        id="New_Pattern_Swatch_3-19"
        data-name="New Pattern Swatch 3"
        width={131}
        height={104}
        patternTransform="translate(-92 -3208)"
        patternUnits="userSpaceOnUse"
        viewBox="0 0 131 104"
      >
        <rect width={131} height={104} fill="none" />
        <rect width={131} height={104} fill="#fbaa2c" />
      </pattern>
      <clipPath id="clip-path-4">
        <path
          d="M340,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-16.47,2.29-16.47-2.34c-4.84,11.17-10.79,35.82-7.21,62.64C355.15,754.36,340,786,340,786Z"
          fill="#fff"
        />
      </clipPath>
      <clipPath id="clip-path-5">
        <path
          d="M654.5,626.35c-10-4.1-16.3-2.31-21.07-3.79-8.07-2.51-39.59-20.38-40.64-29.69-1.63-14.42,4.44-28.64,4.44-28.64-10.22.47-20.17-5.69-20.17-5.69-8.53,13.6-12.19,33.18-11.37,39.59,4.84,37.91,72.45,55.82,76.17,64.66,8.87,21.07,26.16,34.49,25.06,55.81-.72,14.08-3,19.71-9,46.47-4.15,18.71,0,19.7.51,32.39a2.08,2.08,0,0,0,2,2c5.5.22,23.78-.13,68.26-9.12a90.56,90.56,0,0,0,30.61-12.64c-.89-7.21-5.09-15.86-9-26.15-10.11-26.64-8.8-35.44-18.39-87.25-3.69-20-1.79-19.77-1.55-25,.42-9,10.78-42.93,19.94-68.27,10.17-28.12,13.9-59,13.9-59-8.84,2.18-19.8-5-19.8-5-14.55,15.51-18.11,67.11-33.13,92.67Z"
          fill="#13a89e"
        />
      </clipPath>
      <clipPath id="clip-path-6">
        <path
          d="M659.92,614.19s26.23,6.6,38.79-7.57l25.77-2.73-7.11,28.17-35.83,16.58-35.7-13.9v-15Z"
          fill="none"
        />
      </clipPath>
      <linearGradient
        id="linear-gradient"
        x1={8691.01}
        y1={-10.6}
        x2={8091.24}
        y2={1012.53}
        gradientTransform="matrix(-1, 0, 0, 1, 9026.61, 0)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#f9db87" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
    </defs>
    <g
      style={{
        isolation: "isolate",
      }}
    >
      <g id="Layer_15" data-name="Layer 15">
        <path
          d="M1450.5,0H.5V921.63S122.5,993,221.44,895s394.37-87.6,485.79-59.72C801.5,864,1161.29,676.36,1196.5,424c48-344,269-424,269-424"
          fill="#351377"
        />
      </g>
      <g id="DJ">
        <g>
          <path
            d="M583.84,550.74H542.56V482.83H303.47V718.72a5,5,0,0,0,5,5H589.76V556.67A5.93,5.93,0,0,0,583.84,550.74Z"
            fill="#191b30"
          />
          <path
            d="M546.68,628.44a29.11,29.11,0,1,1,29.11-29.11A29.14,29.14,0,0,1,546.68,628.44Zm0-57.28a28.17,28.17,0,1,0,28.17,28.17A28.2,28.2,0,0,0,546.68,571.16Z"
            fill="#ffd04d"
          />
          <path
            d="M546.68,610.41a11.09,11.09,0,1,1,11.09-11.08A11.09,11.09,0,0,1,546.68,610.41Zm0-21.22a10.14,10.14,0,1,0,10.14,10.14A10.15,10.15,0,0,0,546.68,589.19Z"
            fill="#ffd04d"
          />
          <path
            d="M546.68,689.71a20.3,20.3,0,1,1,20.3-20.3A20.32,20.32,0,0,1,546.68,689.71Zm0-39.65A19.35,19.35,0,1,0,566,669.41,19.37,19.37,0,0,0,546.68,650.06Z"
            fill="#ffd04d"
          />
          <path
            d="M546.68,677.24a7.83,7.83,0,1,1,7.82-7.83A7.83,7.83,0,0,1,546.68,677.24Zm0-14.7a6.88,6.88,0,1,0,6.88,6.87A6.88,6.88,0,0,0,546.68,662.54Z"
            fill="#ffd04d"
          />
        </g>
        <path
          d="M493.22,390.44c20.64-18.23,15.21-74.07,16.79-81.28,1.5-6.86,7.07-8.09,9.73-17.87.52-1.92.88-4-.15-6-1.21-2.25-4.23-4.86-7.39-3.38-3.43,1.6-6,12-7.28,11.77-1.11-.19-.13-8.47-1.71-8.78-2.12-.41-3.88,5.51-4.61,12.17a42.49,42.49,0,0,0-.21,9.72c.67,11.77-11,47.94-12.19,53.55Z"
          fill="#efc1ab"
        />
        <path
          d="M439,329.52c7.94,1.33,13.87,1.6,19.23,5,10.3,6.6,28,25.83,28,25.83l18.25,10.27s-6.33,28.2-21.95,33.37c-9.17,3-18.17-12.35-18.17-12.35l3.21,52.49H381.43l4.76-51.47c-7.88-18.41-20.52-49.31-6-58,6.93-4.18,20.11-5.76,20.11-5.76Z"
          fill="#9f4da3"
        />
        <path
          d="M408.86,310v12.45a3.52,3.52,0,0,1-1.51,2.9,41.36,41.36,0,0,1-7.07,3.51s11.93,3.13,19,3.13c8.43,0,19.73-2.5,19.73-2.5a21.68,21.68,0,0,1-8.29-4,3.12,3.12,0,0,1-1.14-2.44l.1-13.08Z"
          fill="#efc1ab"
        />
        <path
          d="M429.61,316c-6.84,3.77-11.61,5.34-20.75-.52v-3.61h20.78Z"
          fill="#9e6352"
          opacity={0.3}
          style={{
            mixBlendMode: "multiply",
          }}
        />
        <path
          d="M439,288l-.4,0,1-7.6c1.28-13.23-9.44-19.87-19.94-19.9h0c-9.57,0-18.56,3.73-19.78,15.68a26.87,26.87,0,0,0,0,5.38l.65,6.33h-.17a4.3,4.3,0,0,0,0,8.59l.3,0c1.08,9.83,6.83,20.65,18.66,20.65h0c12.56,0,18-10.74,19.12-20.58a3.07,3.07,0,0,0,.53.05,4.3,4.3,0,0,0,0-8.59Z"
          fill="#efc1ab"
        />
        <g>
          <path
            d="M440.53,290.44a3,3,0,0,0-1.07,1.36,3.75,3.75,0,0,0-.12,1.91c0,.23.4.13.36-.1a3.37,3.37,0,0,1,.11-1.67,2.56,2.56,0,0,1,.91-1.17c.19-.15,0-.47-.19-.33Z"
            fill="#352d2d"
          />
          <path
            d="M439.68,292.22h.41l.14,0h.06l0,0h0l.1,0,0,0h0l0,0a.3.3,0,0,1,.08.08l0,0s0,0,0,0l0,0a.31.31,0,0,1,0,.1l0,0h0l0,.05,0,.1a.13.13,0,0,0,0,.06s0,0,0,0V293s0,.07,0,.1,0,0,0,0v0a.13.13,0,0,0,0,.06.56.56,0,0,1,0,.12l0,.05s0,0,0,0l-.06.11,0,0s0,0,0,0l0,0a.19.19,0,0,0,0,.27.18.18,0,0,0,.26,0,1.33,1.33,0,0,0,.31-1.05,1.06,1.06,0,0,0-.68-.82,1.75,1.75,0,0,0-.82-.06.2.2,0,0,0-.13.23.19.19,0,0,0,.23.13Z"
            fill="#352d2d"
          />
        </g>
        <g>
          <path
            d="M398.71,290.71a2.59,2.59,0,0,1,.9,1.17,3.27,3.27,0,0,1,.09,1.67c0,.24.33.34.37.1a3.83,3.83,0,0,0-.11-1.9,3.11,3.11,0,0,0-1.06-1.37c-.19-.14-.38.18-.19.33Z"
            fill="#352d2d"
          />
          <path
            d="M399.84,291.81a1.38,1.38,0,0,0-1.25.33,1.17,1.17,0,0,0-.24,1,1.31,1.31,0,0,0,.29.56.18.18,0,0,0,.26,0,.19.19,0,0,0,0-.27s0,0,0,0l0,0-.06-.09,0-.05v0s0,0,0,0a.72.72,0,0,1-.06-.21s0-.06,0,0v0a.41.41,0,0,1,0-.11v-.05s0-.07,0,0a1.17,1.17,0,0,1,.05-.2s0,0,0,0l0,0,.06-.09s0,0,0,0l0,0,0,0,0,0h0l.09-.06,0,0h0l.14,0,.07,0h.06a1.37,1.37,0,0,1,.35,0A.2.2,0,0,0,400,292c0-.09,0-.22-.13-.23Z"
            fill="#352d2d"
          />
        </g>
        <path
          d="M432.42,284.44a44.1,44.1,0,0,0-7.63-.2,1,1,0,1,1-.23-1.93c2.59-.78,6.23,0,7.81.48S434.08,284.72,432.42,284.44Z"
          fill="#512c10"
        />
        <path
          d="M406.77,284.28a42.57,42.57,0,0,1,7.59-.21,1,1,0,1,0,.23-1.92c-2.58-.78-6.2,0-7.77.47S405.13,284.55,406.77,284.28Z"
          fill="#512c10"
        />
        <path
          d="M448.13,270.88c-2.58-3.65-13.3-12.33-21.16-16-1.27-.59-4.94-1.91-7.79.5-2.78-2.36-6.85-1.52-9-.61-2.72,1.13-3.82,2.12-6.2,3.32-2.05,1-7,7.35-9.44,10.9-3.6,5.18,2,23,6,19,.32-.32,0-14,10.36-18.13,5.53-2.2,7-3.1,7.8-5.17a7.74,7.74,0,0,0,3.67,4.61c2.2,1.53,5.46,2.19,6.79,4.13,1.16,1.69,8.78,13.89,10.53,15.57,6.45,6.2,10-1.43,10.58-4C451.56,279,450.5,274.22,448.13,270.88Z"
          fill="url(#New_Pattern_Swatch_3)"
        />
        <path
          d="M417.85,296a2.14,2.14,0,0,0,.32,2.38,2,2,0,0,0,2.17.24,3.19,3.19,0,0,0,1.25-1.11c.14-.2-.18-.38-.32-.19a2.36,2.36,0,0,1-2,1.14,1.32,1.32,0,0,1-1.26-1,2.23,2.23,0,0,1,.16-1.32c.09-.22-.27-.32-.36-.1Z"
          fill="#352d2d"
        />
        <path
          d="M426.75,411.68c20.82,9.24,46.54,9.8,55.39,12.31,8.29,2.36,10.43,8.76,21.88,13.5,2.3.95,4.93,1.48,7.42.38,2.91-1.29,6.45-4.79,4.91-8.87-1.66-4.41-14.35-8.62-14-10.16.35-1.38,10.54.64,11.08-1.3.72-2.6-6.45-5.14-14.67-6.68a69.17,69.17,0,0,0-12.1-1.4c-14.68-.81-46-14.73-50.61-15.26Z"
          fill="#efc1ab"
        />
        <path
          d="M375.79,444.88h-52a4.2,4.2,0,0,1,4.2-4.2H371.6a4.2,4.2,0,0,1,4.19,4.2Z"
          fill="#ffd04d"
        />
        <path
          d="M526.28,444.88h-52a4.19,4.19,0,0,1,4.19-4.2h43.63a4.2,4.2,0,0,1,4.19,4.2Z"
          fill="#ffd04d"
        />
        <path
          d="M485.62,360.32a146,146,0,0,0-8.08,14.79c-.2.45.46.85.67.39a146,146,0,0,1,8.08-14.79.39.39,0,0,0-.67-.39Z"
          fill="#c767ce"
        />
        <path
          d="M386.32,393.16a65.17,65.17,0,0,0,15.51,11.2A82.6,82.6,0,0,0,419,411.57a28.14,28.14,0,0,0,7.34,1.24.39.39,0,0,0,0-.77c-4.88,0-9.85-1.9-14.31-3.71a89.18,89.18,0,0,1-17.21-9.19,53.85,53.85,0,0,1-7.92-6.52c-.34-.36-.89.19-.54.54Z"
          fill="#c767ce"
        />
        <path
          d="M475.44,367.5l5.23-3.55c.81-.55,1.61-1.12,2.45-1.63A15.79,15.79,0,0,1,486,361c.46-.16.26-.91-.21-.74a16.83,16.83,0,0,0-2.73,1.16c-.9.52-1.75,1.12-2.61,1.71l-5.4,3.66c-.41.28,0,.95.39.67Z"
          fill="#c767ce"
        />
        <path
          d="M402.76,372a28.25,28.25,0,0,0,1.11,5c.3.8,1,1.09,1.69,1.45,7,3.48,13.92,7,20.84,10.64,3.13,1.62,6.31,3.19,9.34,5a.39.39,0,0,0,.39-.67c-2.53-1.49-5.18-2.81-7.78-4.17q-5.94-3.09-11.89-6.12c-3.2-1.63-6.4-3.27-9.62-4.88l-1.24-.62a2.22,2.22,0,0,1-1.23-1.71c-.21-.87-.4-1.75-.58-2.62-.69-3.46-1.13-6.95-1.57-10.44-.94-7.49-1.88-15.09-5.08-22-.2-.45-.87-.06-.66.39h0c3,6.47,4,13.6,4.84,20.6"
          fill="#c767ce"
        />
        <path
          d="M397.84,331.39a1.21,1.21,0,0,0,0,.18,7.13,7.13,0,0,0-1.77,6.85c.94,3.73,4.37,6.08,7.67,5.25s5.21-4.52,4.27-8.25a6.92,6.92,0,0,0-5.68-5.37c.14-.24.26-.49.41-.72s.35-.52.54-.78l.18-.24.23-.28a17.41,17.41,0,0,1,1.25-1.33l.64-.58.37-.31.19-.15a16.26,16.26,0,0,1,1.46-1c.32-.19.54-.31.87-.48a3.85,3.85,0,0,0,.44-1.8v-2.17A18.49,18.49,0,0,0,397.84,331.39Z"
          fill="#333"
        />
        <path
          d="M404.56,377.42c-3.74,1.73-7.63,4.09-8.93,8.25-.15.47.59.68.74.2,1.24-3.95,5-6.15,8.58-7.78.45-.21.06-.88-.39-.67Z"
          fill="#c767ce"
        />
        <path
          d="M404.14,376.76A29.85,29.85,0,0,0,391.48,378c-.47.15-.26.9.21.74a29.35,29.35,0,0,1,12.45-1.25c.49.06.49-.71,0-.77Z"
          fill="#c767ce"
        />
        <rect
          x={279.66}
          y={444.16}
          width={286.78}
          height={59.37}
          rx={6.39}
          fill="#191b30"
        />
        <path
          d="M565.91,454.2h-7.69l-20.73,0-30.87,0-37.4,0-41.24,0-41.34,0-38.82,0-32.58,0-23.59,0c-3.7,0-7.41,0-11.11,0h-.48a.39.39,0,0,0,0,.77h28.42l30.87,0,37.4,0,41.24,0,41.34,0,38.82,0,32.58,0,23.59,0c3.7,0,7.41,0,11.11,0h.48a.39.39,0,0,0,0-.77Z"
          fill="#ffd04d"
        />
        <path
          d="M420,307.52c-2.74.48-4.65-.36-5.38-1.15a.24.24,0,0,1,.13-.4s3-.29,4.89-.63,4.84-1.06,4.84-1.06c.19,0,.28,0,.21.2C424.32,305.46,422.92,307,420,307.52Z"
          fill="#fff"
        />
        <path
          d="M542.18,550.36H509.94a6.91,6.91,0,0,0-4.13,1,6,6,0,0,0-2.59,5c-.05,2.6,0,5.21,0,7.81V723.28a.39.39,0,0,0,.77,0V557.38c0-1.91.26-3.73,1.88-5.07a6.29,6.29,0,0,1,4.27-1.18h32a.39.39,0,0,0,0-.77Z"
          fill="#ffd04d"
        />
        <path
          d="M550.57,550.36h32.24a7,7,0,0,1,4.14,1,6.07,6.07,0,0,1,2.59,5c0,2.6,0,5.21,0,7.81V723.28a.39.39,0,0,1-.78,0V557.38c0-1.91-.26-3.73-1.88-5.07a6.28,6.28,0,0,0-4.27-1.18h-32a.39.39,0,0,1,0-.77Z"
          fill="#ffd04d"
        />
        <path
          d="M440.59,332.07s0-.08,0-.11a18.43,18.43,0,0,0-11-11.17l0,2.16a3.18,3.18,0,0,0,.44,1.8c.34.17.55.3.87.49a15.61,15.61,0,0,1,1.46,1l.19.15.36.3.65.59a15.61,15.61,0,0,1,1.24,1.33l.23.28s.17.22.18.24q.29.38.54.78c.16.23.28.48.42.72a6.94,6.94,0,0,0-5.62,5.37c-.94,3.72,1,7.42,4.27,8.25s6.73-1.53,7.67-5.25A7.06,7.06,0,0,0,440.59,332.07Z"
          fill="#333"
        />
        <path
          d="M278.18,548.36H245.94a6.91,6.91,0,0,0-4.13,1,6,6,0,0,0-2.59,5c-.05,2.6,0,5.21,0,7.81V721.28a.39.39,0,0,0,.77,0V555.38c0-1.91.26-3.73,1.88-5.07a6.29,6.29,0,0,1,4.27-1.18h32a.39.39,0,0,0,0-.77Z"
          fill="#ffd04d"
        />
        <g>
          <path
            d="M245.38,549.12h42.21l33.4-.32a6.76,6.76,0,0,1,6.83,6.77L327.42,726H240.33V555.18C239.33,551.84,242,549.12,245.38,549.12Z"
            fill="#191b30"
          />
          <path
            d="M283.37,628.55a29.76,29.76,0,1,1,29.75-29.76A29.79,29.79,0,0,1,283.37,628.55Zm0-58.56a28.81,28.81,0,1,0,28.8,28.8A28.83,28.83,0,0,0,283.37,570Z"
            fill="#ffd04d"
          />
          <path
            d="M283.37,610.12a11.33,11.33,0,1,1,11.33-11.33A11.35,11.35,0,0,1,283.37,610.12Zm0-21.7a10.38,10.38,0,1,0,10.38,10.37A10.39,10.39,0,0,0,283.37,588.42Z"
            fill="#ffd04d"
          />
          <path
            d="M283.37,691.2a20.75,20.75,0,1,1,20.74-20.75A20.77,20.77,0,0,1,283.37,691.2Zm0-40.54a19.8,19.8,0,1,0,19.8,19.79A19.82,19.82,0,0,0,283.37,650.66Z"
            fill="#ffd04d"
          />
          <path
            d="M283.37,678.44a8,8,0,1,1,8-8A8,8,0,0,1,283.37,678.44Zm0-15a7,7,0,1,0,7,7A7.05,7.05,0,0,0,283.37,663.41Z"
            fill="#ffd04d"
          />
        </g>
        <path
          d="M286.57,548.36h32.24a7,7,0,0,1,4.14,1,6.07,6.07,0,0,1,2.59,5c0,2.6,0,5.21,0,7.81V721.28a.39.39,0,0,1-.78,0V555.38c0-1.91-.26-3.73-1.88-5.07a6.28,6.28,0,0,0-4.27-1.18h-32a.39.39,0,0,1,0-.77Z"
          fill="#ffd04d"
        />
        <path
          d="M340.36,655.81a6.23,6.23,0,0,0,8.86.72,1.51,1.51,0,0,0,0-2.12,1.55,1.55,0,0,0-2.12,0c.31-.25-.08.05-.15.1s-.25.15-.38.22l-.2.09.05,0-.42.14-.44.1h.07l-.22,0h-.66c-.18,0-.15,0,.08,0-.08,0-.33-.07-.41-.09a3.17,3.17,0,0,1-.41-.12l-.19-.07.07,0-.37-.2-.36-.22c-.13-.1-.11-.09.06,0a1.07,1.07,0,0,1-.16-.14,4.69,4.69,0,0,1-.58-.6,1.49,1.49,0,0,0-2.12,0,1.54,1.54,0,0,0,0,2.12Z"
          fill="#8f493b"
        />
      </g>

      <g id="People">
        <g>
          <g>
            <g>
              <path
                d="M199.38,382s-10.25-1-12.77-8.51-4.82-34.34-3-36.24,3.43,10.86,5.33,18.94c0,.37-1.66-18.18.07-20s4.45,14.23,4.62,19.41,4.65-2.28,9.56,14.3S199.38,382,199.38,382Z"
                fill="#ad6b55"
              />
              <path
                d="M193.86,358.62s-.36-4.33.42-4.26,3.4.13,3.84,1.67a5.35,5.35,0,0,1,.33,2s.46-1.13,1.34-.73,3.42.87,2.85,3.07,1.05,7.77.11,9.91S193.86,358.62,193.86,358.62Z"
                fill="#ad6b55"
              />
            </g>
            <path
              d="M193.48,375.66a.21.21,0,0,0,.19-.11,7.32,7.32,0,0,0-1.72-9.41,15.93,15.93,0,0,0,3.49-1.19c1.33-.57,2.09-1.23,2.24-1.94a1.17,1.17,0,0,0-.23-1l-.07-.08h-.11l-8.4.55-3.65,5.92a.22.22,0,0,0,.07.3.22.22,0,0,0,.31-.07l3.53-5.72,8-.52a.76.76,0,0,1,.08.56c-.09.39-.51,1-2,1.63-2.92,1.27-3.85,1.2-3.85,1.2l-.85-.08.7.48a6.92,6.92,0,0,1,2,9.18.23.23,0,0,0,.09.31Z"
              fill="#9c5844"
            />
          </g>
          <path
            d="M142.42,387.3s-1.92,20.4-13.78,24.88-12.21,27.9,3.92,34.49,37.22,2.64,43.29-7.64-17.76-16.18-16.69-36.23C156.54,394.35,142.42,387.3,142.42,387.3Z"
            fill="#ad6b55"
          />
          <path
            d="M140.2,397.46s6.05,19.44,17.89,13C166.59,406.74,140.2,397.46,140.2,397.46Z"
            fill="#9c5844"
          />
          <path
            d="M162.07,415.29a61.15,61.15,0,0,1,18.87,9.84c10.65,6.35,29,16.29,29,16.29S202.23,415.67,199,406.1c-8-23.61-6.46-34.41-6.46-34.41s.35-9.79,5.88-5.06,15.32,34.19,19.74,43.76,20.84,47.53,9.18,55.52-60.51-27.47-74.54-25.11C142.91,441.41,162.07,415.29,162.07,415.29Z"
            fill="#ad6b55"
          />
          <path
            d="M98.65,579.85s-6,43.24,4,191.38c2,11.73,15.08,14.07,19.1,0s10.5-184.07,10.5-184.07Z"
            fill="#ad6b55"
          />
          <path
            d="M175.94,357.15s5.43,50.9-13.34,51.19-27-15.23-28.88-26.14,0-32.4,19.64-32.57S175.94,357.15,175.94,357.15Z"
            fill="#ad6b55"
          />
          <path
            d="M181.19,582.92s38.68,139.76,41.23,172.5c1.35,17.45-15.3,6.63-19.89-5.06-10.18-25.94-54.83-155.51-54.83-155.51Z"
            fill="#ad6b55"
          />
          <path
            d="M177,432.65s7.92,16,2.77,34.2S177,523.4,177,523.4s-31.13,10.67-62.77-7.52c-1.19-1.19-1.76-16.16,4.9-23.33,9.4-10.1-5.26-48,.2-68.87C130.37,422.55,177,432.65,177,432.65Z"
            fill="#ad6b55"
          />
          <path
            d="M177,432.65s-6.42,13.65-57.87-2.65c-1.41-.78-3.17,15.52,3,41.36,0,0,38.46-2.83,56.27,2.11,0-.12,3.77-10.9,4.71-16.82S186.85,444.23,177,432.65Z"
            fill="#26211d"
          />
          <path
            d="M176.51,499.64s-26.3,9.37-59-4.87C117,495.48,95.63,521.91,85.1,602c-.76-1.13,44.38,26.33,112.09,3C197.19,605,176.94,511.13,176.51,499.64Z"
            fill="#26211d"
          />
          <path
            d="M124.56,436.84s-5,18.87-9.37,30.9c-6.4,17.68-40,82.49-40,82.49s-2.1,17.1-13.68,23.66c-3.46,2.26,7.23-10,4.88-17-2-3.87-19.82,12.35-19.82,12.35a21.61,21.61,0,0,0-2.63,5.51,1.39,1.39,0,0,1-2.57.22c-1.27-2.51-2.77-5.89-2.7-7.76.13-3.28,2-12.32,8.14-15.47s16.3-10.23,16.3-10.23,35.43-74.35,36.19-85.64c.57-8.55,5-25.57,7.2-31.28,0,0,3.35-15.19,19.86-12.89S124.56,436.84,124.56,436.84Z"
            fill="#ad6b55"
          />
          <path
            d="M177,432.65l-10.07-16-1.6-.34s10.31,20.58-4.66,20.48-23.44-3.63-26.7-9.28-5.36-15.31-5.36-15.31l-2.3-.52s4.16,16.14.39,22.19C126.1,439.41,176.43,451.6,177,432.65Z"
            fill="#26211d"
          />
          <g>
            <path
              d="M139.13,387s1.4,8-2.24,10.94c0-.1-1.89-4.29-4.52-10.94S139.13,387,139.13,387Z"
              fill="#a32b28"
            />
            <path
              d="M137.63,356.9s-.25-9.66-8.65-7.27-10.28,8.78-7.27,12.91,13.79,4.64,15,.63A15,15,0,0,0,137.63,356.9Z"
              fill="#a32b28"
            />
            <g>
              <path
                d="M169.45,357.59s1.51,9.69-2.91,14.3-5.89,11.66-5.89,11.66,1.94-6.4,6-9.88,6.84-14.86,4.6-17.3S169.45,357.59,169.45,357.59Z"
                fill="#a32b28"
              />
              <g>
                <path
                  d="M143.78,373s-.85,31.14,1.6,41.66c-.2-.39-2.83,0-2.83,0s-5.35-22-4.89-28.4c-.87.83-1.45,5.55-2.28,7.81s-7.12-1.89-7.12-1.89-5.68-35.81,12.88-42.77,26,3.09,26,3.09Z"
                  fill="#a02410"
                />
                <path
                  d="M170.93,359.35c-.22.38-4.52,11.72-14.17,11.72s-10.66,8.07-15.55,6.23-2-10.61,3-17,6.63-13.89,15.6-12.42S173.94,353.94,170.93,359.35Z"
                  fill="#a02410"
                />
                <path
                  d="M176.65,370.19s-1.08-9.93-7.06-11.38c-7.51-1.82-7.35-7.69-1.75-8.25S182.52,358.26,176.65,370.19Z"
                  fill="#a32b28"
                />
              </g>
            </g>
          </g>
          <g>
            <path
              d="M261.84,779s2.54,7.9-2.07,10.57c-7,4-24.33,2.69-30.67-2S216.19,781,208.74,782s-15.51-2.6-11.46-12.8C200,762.36,261.84,779,261.84,779Z"
              fill="#677693"
            />
            <path
              d="M219.43,736.05s-12.75,6.18-21.17,2.94c0,0,6,15.79,1.22,24.4-4.4,7.85-3.14,14.29,5.05,14.57s17.66.52,24.43,4.55c4.92,2.29,22.09,7.94,29.34,1.72,9.57-5-1.37-12-12.24-12.18a8.57,8.57,0,0,1-7-2.23c-3.29-3-4.88-5.11-8.92-7.68S222.34,737.07,219.43,736.05Z"
              fill="#26211d"
            />
          </g>
          <g>
            <path
              d="M125.75,801.9s.06,6.76-3.54,8.28-27.52-.85-29.23-5.53a7.64,7.64,0,0,1,0-7Z"
              fill="#677693"
            />
            <path
              d="M101.82,773.14s-11,22.62-8.44,26.55c5.09,6,30.51,6.34,32.37,2.21s-5.17-26.36-5.17-26.36S110.49,770.88,101.82,773.14Z"
              fill="#26211d"
            />
          </g>
          <g opacity={0.54}>
            <path
              d="M92.36,605c5.87-60.46,30.73-107.4,31-107.87l-.65-.35c-.25.47-25.18,47.54-31.07,108.15Z"
              fill="#e49e38"
            />
            <path
              d="M101.48,608.3c8.57-63.1,26.93-109,27.12-109.43l-.69-.28c-.18.46-18.58,46.42-27.16,109.61Z"
              fill="#e49e38"
            />
            <path
              d="M111.73,611c2.35-49.46,22.17-110.08,22.37-110.69l-.7-.23c-.2.61-20.05,61.32-22.4,110.89Z"
              fill="#e49e38"
            />
            <path
              d="M122.65,611h.73c-.26-37.32,17-108.7,17.16-109.41l-.71-.18C139.65,502.12,122.38,573.58,122.65,611Z"
              fill="#e49e38"
            />
            <path
              d="M134.7,614.26l.73,0c-.74-34.87,12.33-111,12.46-111.8l-.72-.12C147,503.08,134,579.32,134.7,614.26Z"
              fill="#e49e38"
            />
            <path
              d="M148.25,614.31l.72-.12c-5.2-33.36,3.93-110.73,4-111.5l-.73-.09C152.17,503.38,143,580.84,148.25,614.31Z"
              fill="#e49e38"
            />
            <path
              d="M189.57,607.48l.71-.2c-10.16-35.47-17.5-105.83-17.57-106.54l-.74.08C172.05,501.53,179.39,572,189.57,607.48Z"
              fill="#e69f39"
            />
            <path
              d="M178.62,610.38l.71-.21c-8.15-27.38-13.68-107-13.74-107.82l-.73,0C164.91,503.21,170.45,582.92,178.62,610.38Z"
              fill="#e49e38"
            />
            <path
              d="M163.55,613.11l.72-.15c-6.49-30.61-4.72-109.51-4.7-110.31l-.73,0C158.82,503.43,157,582.42,163.55,613.11Z"
              fill="#e49e38"
            />
          </g>
          <path
            d="M121.41,778.27l3.42-37.48s-12.11,2.58-24.09,0c0,.23,1.43,36.15,1.43,36.15Z"
            fill="#26211d"
          />
        </g>
        <g>
          <g>
            <g>
              <path
                d="M1042.05,716.1s-2.84,5.23-3.2,8.2c-1,8.22-1.12,24.31-4.18,25.94-2.28,1.22-3.35-.53-3.35-.53-.87,1.94-1.63,3.74-3.66,3.88-.94.07-2.18-1.06-2.18-1.06-.7,1.92-2.07,3.19-3.53,3.23-2.14.06-3.2-2.82-3.2-2.82-.83,2.93-5.57,14.61-8.1,14.17-2.72-.48-2.28-4.13-1.53-7.24,1.43-5.94,2.75-10.92,2.75-10.92-1.26,1.76-3.64,2.07-4.46,1-1-1.29.22-3.82,1.94-9.13,2.85-8.85,1.89-8.06,3-10,3.22-5.61,5.49-6,8.75-11.78a34.75,34.75,0,0,0,3.31-9.2C1028.75,706.78,1041,711.17,1042.05,716.1Z"
                fill="#dba795"
              />
              <path
                d="M1012.49,748.82a12.06,12.06,0,0,0,2.47-5.75,16.39,16.39,0,0,1,2-6.32.42.42,0,0,0-.72-.44,15.47,15.47,0,0,0-2,5.89,12.33,12.33,0,0,1-2.47,6.18c-.34.42.38.86.72.44Z"
                fill="#9e695c"
                opacity={0.2}
                style={{
                  mixBlendMode: "multiply",
                }}
              />
            </g>
            <path
              d="M1019.46,752.66a46,46,0,0,0,2.31-13.5.43.43,0,0,0-.85,0,44.89,44.89,0,0,1-2.29,13.28.43.43,0,0,0,.83.22Z"
              fill="#9e695c"
              opacity={0.2}
              style={{
                mixBlendMode: "multiply",
              }}
            />
            <path
              d="M1025.91,752.26a27.37,27.37,0,0,0,1.82-6.4,18.75,18.75,0,0,0,.34-6.46c-.11-.54-.93-.31-.83.22a17.81,17.81,0,0,1-.37,6.25,25.7,25.7,0,0,1-1.7,6c-.21.5.52.94.74.43Z"
              fill="#9e695c"
              opacity={0.2}
              style={{
                mixBlendMode: "multiply",
              }}
            />
            <path
              d="M1032,749.35c.35-1.75.69-3.5,1-5.26a17.72,17.72,0,0,0,.23-5.24c-.07-.53-.92-.54-.85,0a17.51,17.51,0,0,1-.24,5.21c-.28,1.7-.6,3.38-.94,5.06-.11.54.71.77.82.23Z"
              fill="#9e695c"
              opacity={0.2}
              style={{
                mixBlendMode: "multiply",
              }}
            />
            <g>
              <path
                d="M829.76,595s.31-5.94-.65-8.78c-2.65-7.84-9.48-22.41-7.43-25.2,1.54-2.09,3.26-1,3.26-1-.06-2.12-.15-4.08,1.62-5.08a4,4,0,0,1,2.43,0c-.2-2,.49-3.77,1.79-4.44,1.9-1,4,1.19,4,1.19,3.18-1-2.68-18.2,1-19.12,2.68-.67,3.57,3.53,4.87,8.68,1.5,5.93,2.23,11,2.23,11,.38-2.13,2.39-3.43,3.58-2.84,1.47.72,1.45,3.54,2.2,9.08,1.24,9.2,1.76,8.08,1.59,10.34-.48,6.45-2.36,7.79-2.8,14.41a34.43,34.43,0,0,0,1,9.72C845.79,597.67,832.82,599,829.76,595Z"
                fill="#dba795"
              />
              <path
                d="M838.78,564.64a54.48,54.48,0,0,0-3.4-12.41c-.2-.51-1-.16-.77.35a55.07,55.07,0,0,1,2.9,9.74c.16.77.29,1.55.41,2.33.16,1,.29,2.21-.87,2.6-1.74.58-3-1.06-3.82-2.31,0-.05-.08-.05-.12-.08-1-3.09-2.14-6.17-3.44-9.16-.21-.5-1-.15-.77.35,1.37,3.17,2.53,6.41,3.63,9.68.26.8.53,1.59.79,2.39s.62,1.67.09,2.43c-1.18,1.66-3.29.51-4.17-.78,0-.06-.1-.06-.15-.09a2.86,2.86,0,0,0-.07-.28,52.61,52.61,0,0,0-3.32-8.76c-.24-.49-1-.15-.77.35a50.86,50.86,0,0,1,2.71,6.73,13.51,13.51,0,0,1,.88,3.47c.05,1.59-1.51,2-2.76,1.36-.46-.26-1,.42-.49.68a2.82,2.82,0,0,0,3.41-.16,2.35,2.35,0,0,0,.66-1.9,3.33,3.33,0,0,0,3.38.88,2.68,2.68,0,0,0,1.58-3.62c-.15-.48-.32-1-.48-1.44a3.54,3.54,0,0,0,2.65,1.21,2.45,2.45,0,0,0,2-1A3.7,3.7,0,0,0,838.78,564.64Z"
                fill="#9e695c"
                opacity={0.2}
                style={{
                  mixBlendMode: "multiply",
                }}
              />
              <path
                d="M842.27,553.11a12,12,0,0,0,.25,6.26,16.65,16.65,0,0,1,.9,6.56.42.42,0,0,0,.84.09,15.26,15.26,0,0,0-.72-6.18,12.21,12.21,0,0,1-.43-6.64c.12-.53-.72-.61-.84-.09Z"
                fill="#9e695c"
                opacity={0.2}
                style={{
                  mixBlendMode: "multiply",
                }}
              />
            </g>
            <path
              d="M939.65,746.6C961.53,759.66,973.79,759.21,985,760c0,0,2.35-24.18-8-30.23C965.55,723.12,946.76,729.08,939.65,746.6Z"
              fill="#c4432d"
            />
            <g>
              <path
                d="M974.68,797l-19.55,19.57c13,9.06,18.67,25.51,18.67,25.51L991.47,823l-.25-6.47A62.17,62.17,0,0,1,974.68,797Z"
                fill="#dba795"
              />
              <g>
                <path
                  d="M950.22,881.67l54.95-55a41.09,41.09,0,0,0-13.11-10.23.71.71,0,0,0-.9.22l-19.8,27.88a1.51,1.51,0,0,1-1.75.53,1.54,1.54,0,0,1-.93-1.76l2-9.53a1.44,1.44,0,0,0-.33-1.29,1.41,1.41,0,0,0-2.31.39l-8.41,19.8c-2.94,6.62-5.6,15.36-9.51,21.45A6.36,6.36,0,0,0,950.22,881.67Z"
                  fill="#f4e2ca"
                />
                <path
                  d="M977,836.63h0a11,11,0,0,0-3.11-1.57,11.11,11.11,0,0,0-3.29-.5h0l-1.88,8.77a1.5,1.5,0,0,0,2.69,1.18Z"
                  fill="#281a24"
                />
                <path
                  d="M951.59,883.05l-1.37-1.38,54.95-55,2.63,2.62a1.69,1.69,0,0,1-.36,2.3l-50.58,50.65C955.18,883.89,952.82,884.27,951.59,883.05Z"
                  fill="#281a24"
                />
              </g>
            </g>
            <g>
              <g>
                <g clipPath="url(#clip-path)">
                  <path
                    d="M944.21,964.21c.92-9.16-1.44-19.22-3.12-20.09-3.29,12.22-25.75,9.17-29.83,30.52a6.18,6.18,0,0,0,.14,3.05c1.62,5,4.52,8.68,14.08,9.06h5c6.42,0,13.19-4.37,15-9.7h0a6.28,6.28,0,0,0,.3-3C945.42,971.27,943.88,967.56,944.21,964.21Z"
                    fill="#281a24"
                  />
                  <path
                    d="M944.77,959.56c.92-9.16-1.65-19.29-3.32-20.16-3.29,12.22-25.75,9.17-29.83,30.52a6.18,6.18,0,0,0,.14,3.05c1.62,5,4.52,8.68,14.08,9.06h5c6.42,0,13.18-4.37,15-9.7h0a6.14,6.14,0,0,0,.29-3C945.77,966.55,944.44,962.91,944.77,959.56Z"
                    fill="#f4e2ca"
                  />
                </g>
                <path
                  d="M940.75,917c-.22,7.26-1.69,19.44.19,26.52,1.25,4.74.17,11.07-.19,16.25-.07.91-.54,2.63-4.13-.44-2.4-2.06-5.21-3.82-8.39-3.79a12.8,12.8,0,0,0-7.61,3.14s-4.69,3.08-4,.58c1.34-4.59,2.44-9.23,2.25-12.42-.41-7.07-2.71-18.11-5.76-31.34Z"
                  fill="#dba795"
                />
              </g>
              <path
                d="M936.62,959.3h0a3.86,3.86,0,0,1,1.93-.2,7.46,7.46,0,0,1,2.2.64h0l2.57,7.11c.24.67,0,1.1-.56,1a2.15,2.15,0,0,1-1.12-.91Q939.14,963.09,936.62,959.3Z"
                fill="#281a24"
              />
              <path
                d="M920.62,958.65h0a3.63,3.63,0,0,0-1.83-.13,7.52,7.52,0,0,0-2.12.71h0l-2.72,7c-.25.65,0,1.06.5.91a2.26,2.26,0,0,0,1.1-.93Z"
                fill="#281a24"
              />
            </g>
            <path
              d="M894.1,684.62c-13.43,13.16-11.47,27.56-9.14,99.16C888.39,889,900.08,912.62,906.6,932.52h35.88c8.59-30.74-9-68.28-10.55-105.69-.08-2,2.68-25.85-.73-39.76,0,0,7.87,12.4,22.62,36.14l26.17-26c-5.11-31.2-26-45.33-23.7-46.21,12.77-4.78,35.44-19.49,39.79-40.88,2.44-12-5.89-23.08-7.83-25.33Z"
              fill="url(#New_Pattern_Swatch_8)"
            />
            <path
              d="M905.5,939c18.79,6.66,38.57-.71,38.57-.71l.85-13.59a147.69,147.69,0,0,1-21.63,2.11,153.15,153.15,0,0,1-19.78-1.35Z"
              fill="#382632"
            />
            <path
              d="M956.8,828.44c19.25-5.15,31.39-22.42,31.39-22.42l-7-11.69a148.61,148.61,0,0,1-16.63,14,154.08,154.08,0,0,1-17.07,10.1Z"
              fill="#382632"
            />
            <g opacity={0.35}>
              <path
                d="M943.06,686.84c-6.75,9.33-15.08,17-23.81,24.38-7,5.95-14.08,12.49-17,21.49-3.14,9.75,2.91,17.95,8.32,25.62,6.68,9.51,14.28,18.33,20.2,28.35a.43.43,0,0,0,.74-.43c-5.3-9-11.92-17-18-25.34a112.43,112.43,0,0,1-8.81-13.53c-3.2-6-3.09-11.85-.15-18,4.07-8.51,11.71-14.44,18.72-20.41a125.68,125.68,0,0,0,20.56-21.69c.32-.45-.42-.87-.74-.43Z"
                fill="#281a24"
              />
            </g>
            <path
              d="M896.24,554.49c-17.49,39.36,3.11,131,3.11,131,20.62,3.2,30.28,2.56,48.57,1.38,11-.71,16,.94,19-1.27,0,0-.79-26.8-7.34-76.13-4.57-34.39-13.73-47.28-18.09-58Z"
              fill="#a02410"
            />
            <g>
              <g>
                <path
                  d="M902.34,535.15l.63,12c.08,1.43-.4,5.49-6.73,7.39,0,0,9.82,7.4,21.92,6.76,19.53-1,23.28-9.79,23.28-9.79l-3.75-.62a8.94,8.94,0,0,1-7.64-8.27l-.4-8.87Z"
                  fill="#dba795"
                />
                <path
                  d="M930,540.81c-5.72,5.81-16.87,7.45-27.25,1.46l-.26-4.81,27.3-1.45Z"
                  fill="#9e695c"
                  opacity={0.2}
                  style={{
                    mixBlendMode: "multiply",
                  }}
                />
                <path
                  d="M939.08,505.59l-.5.05.74-9.19c.73-15.95-12.91-23.23-25.88-22.57h0c-11.82.59-22.67,5.68-23.42,20.11a31,31,0,0,0,.39,6.45l1.2,7.56h-.21a5.16,5.16,0,0,0,.52,10.31l.55-.07c2.43,15,10.88,23.49,24.17,24.5h0c14.09-2.46,22.84-10.84,22.08-26.8.22,0,.65,0,.87,0a5.16,5.16,0,0,0-.51-10.31Z"
                  fill="#dba795"
                />
                <path
                  d="M941.89,511.16a1.27,1.27,0,0,0-.89-.94,1.77,1.77,0,0,0-.69-.05,3.29,3.29,0,0,1,1-1.36c.22-.18,0-.56-.26-.37a3.78,3.78,0,0,0-1.23,1.7,4.45,4.45,0,0,0,0,2.29c.06.29.5.14.44-.14a4.22,4.22,0,0,1-.06-1.66,1.63,1.63,0,0,1,.31,0h.14l.17,0,.07,0h0a.38.38,0,0,1,.13.06l.05,0h0l0,0,.1.09,0,0,0,0,.07.11v0l0,.05a.5.5,0,0,1,0,.13.06.06,0,0,1,0,0v0s0,.09,0,.13v.14a.17.17,0,0,1,0,.07l0,.15a.14.14,0,0,0,0,.06c0-.05,0,0,0,0a.83.83,0,0,1-.07.13.21.21,0,0,1,0,.06h0l0,0a.23.23,0,0,0,0,.32.25.25,0,0,0,.33,0A1.6,1.6,0,0,0,941.89,511.16Z"
                  fill="#9e695c"
                  opacity={0.5}
                  style={{
                    mixBlendMode: "multiply",
                  }}
                />
                <path
                  d="M891.06,512.66a3.7,3.7,0,0,0-1.39-1.57c-.25-.16-.46.24-.22.4a3.06,3.06,0,0,1,1.13,1.24,1.53,1.53,0,0,0-1.18.49,1.37,1.37,0,0,0-.23,1.25,1.49,1.49,0,0,0,.39.65.22.22,0,0,0,.32,0,.22.22,0,0,0,0-.31s-.06-.07,0,0l0,0a1,1,0,0,0-.08-.11l0-.06v0l-.06-.13,0-.12v0s0,0,0,0,0-.08,0-.12V514s0-.1,0,0a1.05,1.05,0,0,1,.06-.24s0,0,0,0l0-.05.06-.12c0,.05,0,0,0,0l0,0,0-.05,0,0s0,0,0,0l.11-.08.06,0h0a.58.58,0,0,1,.17-.06l.09,0h.06a1.53,1.53,0,0,1,.37,0,4.05,4.05,0,0,1,.11,1.66c0,.29.42.38.46.1A4.42,4.42,0,0,0,891.06,512.66Z"
                  fill="#9e695c"
                  opacity={0.5}
                  style={{
                    mixBlendMode: "multiply",
                  }}
                />
                <path
                  d="M937.71,474.39c-1.77-4.85-17.87-14.52-43-3.51,0,0-3.87-2.56-7.43,8.17-2.5,7.51-1.58,23.82,3.11,29.11l1.24-.16c2.91-2.1-3.85-16.78,2.46-20.6,34.26-2,41.78-2,41.78-2,1.92,4.07,2.73,20.28,2.73,20.28a7.31,7.31,0,0,1,1.86.07C942.7,501.7,942.21,486.72,937.71,474.39Z"
                  fill="#061a47"
                />
                <path
                  d="M915.62,516.17c-.18,1-.43,1.93-.67,2.89a11.31,11.31,0,0,0-.42,2.05,1.4,1.4,0,0,0,.36,1.24,2.17,2.17,0,0,0,1.64.4,2.76,2.76,0,0,0,2-1.46c.16-.27-.28-.5-.44-.23a2.16,2.16,0,0,1-2,1.22c-.52,0-1-.25-1-.79a6.6,6.6,0,0,1,.35-2.06c.26-1,.53-2.09.73-3.16.06-.3-.43-.41-.48-.1Z"
                  fill="#9e695c"
                  opacity={0.5}
                  style={{
                    mixBlendMode: "multiply",
                  }}
                />
                <path
                  d="M916.63,530.4a8.56,8.56,0,0,0,6.2-3.46c.12-.16,0-.36-.27-.34,0,0-3.68.44-6.06.57s-6.12.16-6.12.16c-.22,0-.32.09-.19.24A7.65,7.65,0,0,0,916.63,530.4Z"
                  fill="#fff"
                />
                <path
                  d="M893.56,487.2c-4.62-2-8.58-8-7.28-13.08,1-3.74,3.45-6.53,8.29-9.12,2-1.05,7.57-2.53,14-2.84,5.79-.27,5.88,1.5,12.16,1.75,9.71.4,11.18-1.67,14.62,1,2.82,2.2,3,3.28,6.28,7.46,3.77,4.87,8.68,3.26,10.56,7.33,1,2.18-.35,2.76-1.5,11.15-.87,6.32,1.17,10.14-.44,11.44-3.23,2.6-6.44-2.3-9.85-2.32-4.42,0-8.25-1.68-8.69-2.13-3.05-3.11.09-8.14-2.33-10-2.67-2-6.87,3.89-14.58,3.46-4.77-.27-5-2.64-11.86-3.56C897.42,487.05,896.53,488.47,893.56,487.2Z"
                  fill="#02594f"
                />
                <path
                  d="M938.5,504.23l-6.39,3a7.42,7.42,0,0,0-13.53,4.13l-5.16.27a7.42,7.42,0,0,0-14-2.35l-7.11-2.42-.67,1.17,7.31,2.51a7.11,7.11,0,0,0-.26,2.36,7.42,7.42,0,0,0,14.82.07l5.22-.28A7.43,7.43,0,0,0,933.42,511a7.32,7.32,0,0,0-.65-2.65l5.81-2.72Zm-32.12,14.33a6.1,6.1,0,1,1,5.77-6.42A6.1,6.1,0,0,1,906.38,518.56Zm20-1.06a6.1,6.1,0,1,1,5.77-6.42A6.1,6.1,0,0,1,926.33,517.5Z"
                  fill="#f4e2ca"
                />
              </g>
              <path
                d="M903.17,512.23a4.19,4.19,0,0,1,4.66.16c.27.2.64-.18.36-.38a4.73,4.73,0,0,0-5.3-.23.27.27,0,0,0,.28.45Z"
                fill="#382632"
              />
              <path
                d="M923.65,511.58a4.21,4.21,0,0,1,4.66.16c.27.2.63-.18.36-.38a4.71,4.71,0,0,0-5.3-.22.26.26,0,0,0,.28.44Z"
                fill="#382632"
              />
            </g>
            <g opacity={0.35}>
              <path
                d="M956.23,750.53a47.72,47.72,0,0,0-10.44-18.08c-.37-.4-1,.2-.6.6a46.78,46.78,0,0,1,10.22,17.71.43.43,0,0,0,.82-.23Z"
                fill="#281a24"
              />
            </g>
            <g opacity={0.35}>
              <path
                d="M931.22,828A47.33,47.33,0,0,0,921,808.59c-.36-.41-1,.19-.6.6a46.42,46.42,0,0,1,10,19.07.42.42,0,0,0,.82-.22Z"
                fill="#281a24"
              />
            </g>
            <g opacity={0.15}>
              <path
                d="M894.79,564.92c5.28,5.77,15,7.29,22.47,7.28a44.68,44.68,0,0,0,12-1.67c3.69-1,8.15-2.46,10.84-5.33.45-.48-.27-1.2-.72-.72-2.71,2.89-7.38,4.28-11.12,5.27a43.92,43.92,0,0,1-11,1.43c-7.15,0-16.67-1.43-21.75-7-.44-.48-1.16.24-.72.73Z"
                fill="#281a24"
              />
            </g>
            <g opacity={0.15}>
              <path
                d="M926.58,687.05c-7.28-7.51-10.93-17.58-12.84-27.69-.12-.65-1.11-.37-1,.27,2,10.29,5.71,20.51,13.11,28.15.46.47,1.18-.25.72-.73Z"
                fill="#281a24"
              />
            </g>
            <g opacity={0.15}>
              <path
                d="M932.52,687.18c2.4-5,4.32-11,3.47-16.61-.1-.65-1.08-.37-1,.27.81,5.33-1.1,11.07-3.36,15.83-.28.59.6,1.11.88.51Z"
                fill="#281a24"
              />
            </g>
            <g clipPath="url(#clip-path-2)">
              <path
                d="M941.44,551.46s29.2-.57,41.09,4.72c42,18.69,64.09,55.2,69,78.86,3.62,17.4,9.79,52.77-7.83,87.42,0,0-9.24,3.37-28.05-5.87,0,0,10.46-33.58,5-66.33C1016,622.33,990,608.8,990,608.8c-3.1,11.29-.91,20,2.83,35.16a338.94,338.94,0,0,1,8,43c3.8,32.59,3.91,59.88-15.88,73,0,0-19.13-49.11-41.56-49.47,0,0,8.43-23,6.33-58.28C946.12,590.74,937.44,569.52,941.44,551.46Z"
                fill="#f15931"
              />
              <path
                d="M957,550c-2.23,13.6-.74,27.21.78,40.8q2.43,21.81,3.89,43.7c1.9,28.92,3.54,58.58-3.44,87-.18.74,1,1.06,1.15.32,6.75-27.46,5.43-56,3.69-84q-1.34-21.48-3.65-42.91c-1.6-14.82-3.71-29.72-1.27-44.57.12-.75-1-1.07-1.15-.32Z"
                fill="#f9f5ec"
              />
              <path
                d="M992.39,554.83C987,566,983.94,578,981.33,590c-2.72,12.54-4.42,24.1-2.62,36.93,3.67,26.14,13.42,51.79,11,78.51-1.23,13.76-5.72,27.21-15,37.63-.51.57.33,1.42.84.85,14.87-16.66,17.4-40.06,14.86-61.43-3.28-27.53-15.38-55.1-9.86-83,3-15,6.15-30.24,12.87-44,.34-.69-.69-1.29-1-.6Z"
                fill="#f9f5ec"
              />
              <path
                d="M938.18,563.05a314.34,314.34,0,0,0,30.44,8.53c10.26,2.31,20.76,3.66,30.87,6.57a.6.6,0,0,0,.32-1.15c-10.12-2.91-20.61-4.26-30.87-6.57s-20.44-5.19-30.44-8.53c-.73-.25-1,.9-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M940.52,591.94c7.39,4,15.89,4.73,24.11,5.57,9.48,1,19,1.64,28.49,2.09.76,0,.76-1.16,0-1.19-8.85-.42-17.69-1-26.5-1.89-8.62-.85-17.74-1.39-25.49-5.61-.68-.37-1.28.66-.61,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M945.37,624.29a170.38,170.38,0,0,0,44,1.42c.75-.08.76-1.27,0-1.2a168.79,168.79,0,0,1-43.65-1.37c-.75-.13-1.08,1-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M947.41,650.52c16.4,3,32.65,2.64,49.2,1.38.76,0,.77-1.25,0-1.19-16.44,1.25-32.58,1.65-48.88-1.34-.75-.14-1.08,1-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M946.72,675l28.74,1.15c4.42.18,8.81.21,13.12,1.35,3.91,1,7.67,2.42,11.74,2.69.76,0,.76-1.15,0-1.2-4.58-.3-8.76-2.11-13.2-3.07-3.82-.84-7.77-.81-11.66-1l-28.74-1.16c-.77,0-.77,1.17,0,1.2Z"
                fill="#f9f5ec"
              />
              <path
                d="M944.34,696c11.58,1.06,23.35,4.41,34.27,8.38,10,3.63,18.34,10.5,24.93,18.72.48.59,1.32-.25.84-.85-6.52-8.12-14.76-14.91-24.55-18.68a135.26,135.26,0,0,0-35.49-8.76c-.77-.07-.76,1.12,0,1.19Z"
                fill="#f9f5ec"
              />
              <path
                d="M993,613.78a87.91,87.91,0,0,0,17.41-13.41,86.79,86.79,0,0,0,7.06-8.37c2.16-2.83,4.95-5.79,5.89-9.3a.6.6,0,0,0-1.15-.32c-.9,3.37-3.69,6.3-5.77,9a85.37,85.37,0,0,1-7.25,8.52,87.66,87.66,0,0,1-16.79,12.83.6.6,0,0,0,.6,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M1012.36,636.33A78.76,78.76,0,0,0,1019,627c2-3.33,3.28-7,5.35-10.33,3.89-6.15,9.8-10.77,13-17.37.34-.68-.69-1.29-1-.6-3.16,6.42-8.84,11-12.73,16.88-2,3-3.23,6.53-5,9.7a73.57,73.57,0,0,1-7.14,10.21c-.48.59.36,1.44.84.84Z"
                fill="#f9f5ec"
              />
              <path
                d="M1021.67,653.52a124.79,124.79,0,0,0,18.06-9.67c4.85-3.14,10.38-6.58,12.78-12.08.31-.7-.72-1.31-1-.6-2.47,5.63-8.32,9.1-13.3,12.26a125.54,125.54,0,0,1-17.12,9.06c-.7.31-.1,1.33.6,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M1019,683.54c3.29.48,6.46-.48,9.58-1.42a96.8,96.8,0,0,0,10.2-3.67,98.77,98.77,0,0,0,18.82-10.56c.62-.44,0-1.48-.6-1a99.06,99.06,0,0,1-17.2,9.86,96.73,96.73,0,0,1-9.6,3.66c-3.43,1.1-7.25,2.54-10.88,2-.75-.11-1.08,1-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M1014.39,712.6a2.49,2.49,0,0,0,2.18.7,30.51,30.51,0,0,0,5.67-1.47q6-1.74,11.87-3.85c7.19-2.6,14.71-5.34,20.83-10,.6-.46,0-1.49-.6-1-5.47,4.2-12,6.73-18.42,9.13q-5,1.86-10,3.44-2.54.79-5.08,1.51c-1.2.34-4.5,1.85-5.59.76a.6.6,0,0,0-.85.85Z"
                fill="#f9f5ec"
              />
              <path
                d="M1000.74,575.48c9.47,8.68,20.59,14.72,26.83,26.45,3.21,6.06,5.63,12.56,8.27,18.88,2.74,6.55,5.88,13.09,7.22,20.11,5.48,28.66-6.37,57.51-17.15,83.42-.29.7.86,1,1.15.31,10.87-26.13,22.68-55.14,17.15-84-1.38-7.26-4.68-14-7.51-20.82-2.5-6-4.81-12.07-7.78-17.81-6.3-12.21-17.54-18.35-27.33-27.34-.57-.51-1.41.33-.85.85Z"
                fill="#f9f5ec"
              />
              <path
                d="M993.67,598.46c7.23,3.65,11.5,10.64,16.06,17,5,7,9.9,14.45,11.33,23.06.12.76,1.27.44,1.15-.31-1.48-8.94-6.66-16.69-11.85-23.9-4.58-6.38-8.86-13.25-16.09-16.9-.68-.34-1.28.68-.6,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M990.77,608.58a68.32,68.32,0,0,0,2.79-8.85c.9-3.25,2-6.42,3.13-9.59,2.19-6.16,4.35-12.33,5-18.87.07-.66-1-.65-1,0-.69,6.43-2.86,12.53-5,18.6-1.05,3-2.1,5.93-3,9a74.38,74.38,0,0,1-2.86,9.25c-.25.59.63,1.12.88.51Z"
                fill="#c4432d"
              />
              <path
                d="M1021.09,645.05c.78-6.64,2.55-13.53,7.27-18.52.45-.48-.27-1.2-.73-.72-4.91,5.2-6.75,12.32-7.56,19.24-.08.65.94.65,1,0Z"
                fill="#c4432d"
              />
            </g>
            <g clipPath="url(#clip-path-3)">
              <path
                d="M896.24,554.49s-17.15,6.18-25.92,14.88c-13,12.87-13.06,31.8-15.73,31.39,0,0-.07-10.51-5.18-15.79a41.73,41.73,0,0,0-10.11-.65c-6.42.44-13.34,4.19-13.34,4.19-6.4,20-2.64,80.46,23.12,81.43,22.29.85,32.51-41.86,32.51-41.86-.67,20-2.17,32.73-14.16,66.65-10.74,30.41-11.71,49.8-11.71,49.8,7.5,11.74,31,13.15,31,13.15,10.55-16,7.15-21.76,14.95-70.63,5.06-31.76,8.31-39.43,9.7-63.89C912.64,600.34,909.94,562.29,896.24,554.49Z"
                fill="#f15931"
              />
              <path
                d="M822.26,612.78a57.31,57.31,0,0,0,9.06-.68c2.77-.32,5.52-.7,8.27-1.13,2.91-.46,5.81-1,8.7-1.56,2.61-.52,5.35-.91,7.72-2.21.67-.37.07-1.4-.6-1-2.44,1.33-5.39,1.69-8.08,2.22s-5.36,1-8.06,1.43c-5.52.87-11.41,2-17,1.77-.77,0-.76,1.16,0,1.19Z"
                fill="#f9f5ec"
              />
              <path
                d="M824.74,636.88q8.65-.45,17.29-1.39c5.4-.6,11-1.06,16.1-3,.71-.27.4-1.42-.32-1.15-5.22,2-10.91,2.43-16.42,3s-11.09,1-16.65,1.32c-.77,0-.77,1.23,0,1.19Z"
                fill="#f9f5ec"
              />
              <path
                d="M834.85,663.15c19.19-8.26,37-21,46.69-40,.34-.68-.69-1.28-1-.6-9.56,18.86-27.25,31.39-46.26,39.57-.7.3-.1,1.33.6,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M833.25,584.5c-1,16-1.07,31.73,2.49,47.46a131.3,131.3,0,0,0,7,21.81c2.6,6.18,5.46,12.34,10.5,16.91.57.52,1.41-.32.84-.84-5.59-5.08-8.62-12.32-11.34-19.22a130.43,130.43,0,0,1-6.18-20.47c-3.24-15.16-3-30.27-2.12-45.65,0-.77-1.15-.76-1.19,0Z"
                fill="#f9f5ec"
              />
              <path
                d="M885.37,557.41c25.12,65.12-1.56,133.75-26.29,194.47-.29.71.87,1,1.15.32,19.84-48.71,40.34-99.86,35.73-153.54a151.29,151.29,0,0,0-9.44-41.56c-.27-.71-1.43-.4-1.15.31Z"
                fill="#f9f5ec"
              />
              <path
                d="M855.54,595.7c4.65,7.32,9.73,14.45,12.92,22.57q2.38,6.06,4.46,12.24c1.5,4.41,3.27,9,3.42,13.67,0,.76,1.22.77,1.19,0-.14-4.39-1.64-8.53-3-12.65q-2.28-6.85-4.91-13.58c-3.23-8.22-8.33-15.43-13-22.86-.41-.64-1.44,0-1,.61Z"
                fill="#f9f5ec"
              />
              <path
                d="M864,575a37,37,0,0,1,11.42,5.54c.62.44,1.22-.59.6-1a37.81,37.81,0,0,0-11.71-5.66A.6.6,0,0,0,864,575Z"
                fill="#f9f5ec"
              />
              <path
                d="M858.69,619.78a83.28,83.28,0,0,0,5.71-7.13c2-2.73,4.12-5.4,6-8.24s3.27-5.93,4.82-8.91a36.36,36.36,0,0,0,3.42-8.44c.17-.75-1-1.07-1.15-.32a37,37,0,0,1-3.57,8.67c-1.47,2.81-2.83,5.73-4.55,8.4s-3.61,5-5.44,7.53a88.29,88.29,0,0,1-6,7.6c-.52.56.32,1.41.84.84Z"
                fill="#f9f5ec"
              />
              <path
                d="M874.68,576.54c11,2.31,22.64,2.22,33.05-2.53.7-.32.1-1.35-.6-1-10.09,4.6-21.43,4.65-32.13,2.41-.75-.15-1.07,1-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M880.35,599.71a82.06,82.06,0,0,0,17.27,1.71c5.66.1,11.37-.27,16.68-2.37.71-.28.4-1.43-.32-1.15-5.22,2.06-10.8,2.42-16.36,2.33a81.07,81.07,0,0,1-17-1.67c-.75-.17-1.07,1-.32,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M881.08,619.9a79.15,79.15,0,0,0,33.19,3c.75-.09.76-1.28,0-1.19a78.51,78.51,0,0,1-32.88-2.93c-.73-.23-1,.93-.31,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M879.58,642.32c10.1,4.93,21.24,6.75,32.35,7.66.76.06.76-1.13,0-1.19-10.88-.89-21.85-2.66-31.74-7.49-.69-.34-1.3.69-.61,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M873.93,669.56a65.54,65.54,0,0,0,31.18,4.55c.75-.07.76-1.26,0-1.19a64.91,64.91,0,0,1-30.87-4.51c-.71-.29-1,.86-.31,1.15Z"
                fill="#f9f5ec"
              />
              <path
                d="M866.33,693.66a46.23,46.23,0,0,0,7.87,2.69c3,.89,6.12,1.74,9.2,2.53,6.16,1.59,12.38,3,18.62,4.16.75.14,1.08-1,.32-1.15-6-1.15-12-2.47-18-4q-4.29-1.1-8.55-2.32a51.85,51.85,0,0,1-8.9-2.94c-.69-.35-1.29.68-.6,1Z"
                fill="#f9f5ec"
              />
              <path
                d="M856.7,717.13c2.1,2.72,5.85,4,8.85,5.48,3.78,1.85,7.6,3.6,11.48,5.21s7.94,3.14,12,4.46q3,1,6,1.79c.94.26,2,.69,2.57-.26.43-.64-.6-1.24-1-.6-.2.31-4.54-1.25-5.09-1.42q-2.45-.75-4.86-1.59c-3.44-1.19-6.83-2.51-10.17-3.92s-6.44-2.84-9.6-4.38c-2.87-1.39-7.07-2.77-9.08-5.37-.46-.6-1.49,0-1,.6Z"
                fill="#f9f5ec"
              />
              <path
                d="M881.81,628c-.29-9.27.08-18.57-.78-27.82A78.12,78.12,0,0,0,879,588c-1.13-4.41-3.17-8.55-4.09-13-.13-.64-1.11-.37-1,.28.85,4.14,2.72,8,3.83,12.06a75.9,75.9,0,0,1,2.32,13.81c.75,8.92.42,17.9.7,26.84a.51.51,0,0,0,1,0Z"
                fill="#c4432d"
              />
              <path
                d="M854.45,601.44c2.95,13.1,4.9,26.74,1.78,40-.15.64.84.92,1,.28,3.16-13.45,1.21-27.27-1.78-40.55-.15-.64-1.13-.37-1,.27Z"
                fill="#c4432d"
              />
            </g>
          </g>
          <path
            d="M918.52,480.8c2.18.36,4.14-.56,6.16-1.25a12.6,12.6,0,0,1,7-.19c1.95.45,4.1,1.08,5.49,2.62s1.83,3.69,3.35,5.16a16.56,16.56,0,0,0,5.72,3.17c.59.24.85-.73.26-1a15.37,15.37,0,0,1-5.27-2.91c-1.52-1.47-2-3.62-3.36-5.17a10.11,10.11,0,0,0-5-2.65,15.28,15.28,0,0,0-6.75-.5c-2.44.46-4.78,2.14-7.33,1.72-.63-.11-.9.86-.26,1Z"
            fill="#097263"
          />
          <path
            d="M935.31,475.64c2.58-.74,4.62,1.53,6.21,3.18s3.46,3.25,5.85,3c.64-.06.64-1.06,0-1-2.67.25-4.46-2.09-6.15-3.78s-3.79-3.08-6.17-2.39a.5.5,0,0,0,.26,1Z"
            fill="#097263"
          />
        </g>
        <path
          d="M919.21,501.27c-.59-.66-.21-1.09,1.28-1.56a14.62,14.62,0,0,1,4.75-.49c3.25.2,5.19,2,4.23,1.79a17.52,17.52,0,0,0-6.15-.3C921.55,500.85,919.61,501.72,919.21,501.27Z"
          fill="#052620"
        />
        <path
          d="M908.8,501.67c.43-.75,0-1.12-1.44-1.35a14,14,0,0,0-4.45.25c-2.42.54-4,2.63-3.29,2.36a14.39,14.39,0,0,1,5.3-1.18C906.58,501.61,908.51,502.17,908.8,501.67Z"
          fill="#052620"
        />
      </g>
      <g id="eyes">
        <g>
          <g>
            <path
              d="M827.15,950.86a28.45,28.45,0,0,0,.59,11.62,8.91,8.91,0,0,0,.92,1.92h-.08a38.79,38.79,0,0,1-7.29,1.86c-2.48.47-4.91,1.1-7.37,1.64-1.45.32-2.92.58-4.38.8l-1-2.22c-3.85-19.22-4.65-52.17-2.95-74.91,1.41-19,4.65-20.77,1.41-29.58-4.87-13.22-28.64-18.44-30.57-22.09l18.95-28.54c11.48,7.11,37.24,21.31,43.11,30.36,5.13,7.92,2.25,13.54,2.25,13.54C838.75,892.44,833,915,827.15,950.86Z"
              fill="#d69b6d"
            />
            <g>
              <rect
                x={808.54}
                y={962.59}
                width={16.63}
                height={23.44}
                transform="translate(-39.65 34.66) rotate(-2.37)"
                fill="#305387"
              />
              <path
                d="M870.5,997.52h0a8.36,8.36,0,0,0-7.64-8h0a33.89,33.89,0,0,1-28.17-20.1l-5.12-11.61a1.23,1.23,0,0,0-1.86-.5l-1.86,1.35a7.84,7.84,0,0,0-3.21,6.65l.52,12.6a5.86,5.86,0,0,1-5.61,6.11h0a5.88,5.88,0,0,1-6.11-5.62l-.53-12.95a3.85,3.85,0,0,0-4-3.68l-1.23.05a.4.4,0,0,0-.38.41s-2.13,5.38-.45,34.17c.06,1.07,2.1,3.74,2.1,3.74l16.2-.08,1.25-2.77,15.3,3.9,28.16-1.17Z"
                fill="#a9c9c3"
              />
              <path
                d="M870.5,997.52l-28,1.15a34,34,0,0,1-9.89-1l-3.59-.92a30.82,30.82,0,0,0-8.92-.93l-15.3.63a.62.62,0,0,0-.59.64l0,1.18a6,6,0,0,0,6.28,5.78l13-.54a1.19,1.19,0,0,0,1.13-1.22l-.05-1.47a.77.77,0,0,1,1-.78l6.74,1.68a38.34,38.34,0,0,0,10.78,1.09l23.43-1a4.11,4.11,0,0,0,3.94-4.28Z"
                fill="#305387"
              />
            </g>
          </g>
          <path
            d="M807.53,863.77a8.39,8.39,0,0,0,1.39,1.92,25,25,0,0,0,1.79,1.92,8.38,8.38,0,0,0,4.19,2.29c.42.08.59-.56.18-.63a7.92,7.92,0,0,1-4-2.22,22,22,0,0,1-1.61-1.73,7.94,7.94,0,0,1-1.37-1.89c-.17-.39-.74,0-.57.34Z"
            fill="#bc835a"
          />
          <path
            d="M839.91,856.67c-1.43,4.1-5.72,6-9.41,7.57-.39.16-.06.73.33.57,3.89-1.66,8.21-3.67,9.71-8,.14-.41-.49-.58-.63-.18Z"
            fill="#bc835a"
          />
        </g>
        <g>
          <g>
            <path
              d="M703.57,978.28c-1.84,5-3,11.92-1.72,17.15.17.7.36,1.37.53,2.06h-.07a38.6,38.6,0,0,1-7.52.41c-2.52,0-5,.13-7.55.18-1.48,0-3,0-4.45-.06l-2.06-3.14c1.66-19,4.71-45.38,10.78-67.37,5.06-18.32,10.93-25.4,9.45-34.67-2.22-13.92-12.11-34.55-13.29-38.51l35.63-9.25c1.91,9.65,9.72,29.23,11.44,35.12,2.63,9.06.63,12.57.63,12.57C726.21,928.85,716.2,944.16,703.57,978.28Z"
              fill="#d69b6d"
            />
            <g>
              <rect
                x={678.17}
                y={999.81}
                width={23.44}
                height={16.63}
                transform="translate(-323.11 1690.85) rotate(-89.59)"
                fill="#305387"
              />
              <path
                d="M742.35,1033.91h0a8.35,8.35,0,0,0-7.25-8.34h0a33.91,33.91,0,0,1-27.16-21.45l-4.54-11.84a1.24,1.24,0,0,0-1.84-.59L699.64,993a7.83,7.83,0,0,0-3.53,6.49l-.09,12.61a5.86,5.86,0,0,1-5.91,5.82h0a5.86,5.86,0,0,1-5.82-5.91l.09-13a3.83,3.83,0,0,0-3.81-3.86h-1.24a.39.39,0,0,0-.39.39s-2.39,5.27-2.11,34.11c0,1.07,1.92,3.83,1.92,3.83l16.18.71,1.39-2.71,15.09,4.63,28.18.2Z"
                fill="#a9c9c3"
              />
              <path
                d="M742.35,1033.91l-28-.2a34.17,34.17,0,0,1-9.83-1.51l-3.54-1.1a31.32,31.32,0,0,0-8.86-1.37l-15.32-.1a.61.61,0,0,0-.62.61v1.17a6,6,0,0,0,6,6.08l13,.09a1.17,1.17,0,0,0,1.19-1.16l0-1.47a.77.77,0,0,1,1-.73l6.65,2a38.19,38.19,0,0,0,10.72,1.61l23.45.17a4.11,4.11,0,0,0,4.14-4.09Z"
                fill="#305387"
              />
            </g>
          </g>
          <path
            d="M701.13,894.65a8.51,8.51,0,0,0,1.06,2.29,21.16,21.16,0,0,0,1.45,2.3,8.24,8.24,0,0,0,3.6,2.9c.39.16.57-.48.17-.63a7.74,7.74,0,0,1-3.36-2.82,23.47,23.47,0,0,1-1.26-2,8.59,8.59,0,0,1-1-2.19c-.09-.42-.72-.24-.63.17Z"
            fill="#bc835a"
          />
          <path
            d="M734.28,894c-2.21,3.75-6.74,4.78-10.68,5.61-.42.09-.24.73.17.64,4.13-.87,8.78-2,11.08-5.92a.33.33,0,0,0-.57-.33Z"
            fill="#bc835a"
          />
        </g>
        <path
          d="M741.08,765.64c-4.49-2.51-8.5-5.7-12.73-8.6-4-2.76-8.06-5.53-12-8.37-5.23-3.74-10.51-7.42-15.73-11.19-4.4-3.19-8.55-6.69-12.84-10C678.58,739.1,670.45,753,672,762c.93,5.51,26.14,32.45,26.14,32.45C731.57,831.59,745.82,824,775,842.74a1.74,1.74,0,0,0,2.54-.79c5.48-12.67,20.19-28.37,20.86-29.17-6.54-7.85-13.53-9.5-20.76-16C762,782.76,745.43,767.3,743,765A1.3,1.3,0,0,1,741.08,765.64Z"
          fill="#694c51"
        />
        <path
          d="M716.36,781.07c-1.59-4.9-2.37-10-3.51-15-1.09-4.76-2.15-9.52-3.14-14.3-1.3-6.3-2.67-12.59-3.94-18.9-1.07-5.33-1.74-10.72-2.62-16.08-14.64,2.31-30,7-35,14.6-3.06,4.68-2.86,41.57-2.86,41.57-5.35,47.52,14.62,54,23.51,87.34a2.05,2.05,0,0,0,2.82,1.34c12.65-5.49,33.66-7.2,34.69-7.33-1.13-11.28-5.09-17-6-26.66-1.92-20.88-1.87-42.44-2.11-45.77A1.29,1.29,0,0,1,716.36,781.07Z"
          fill="#694c51"
        />
        <path
          d="M687.15,853.23c5.46-2.79,11.74-4.42,17.69-5.81a122.34,122.34,0,0,1,18.75-2.85c.42,0,.42-.69,0-.66a123.46,123.46,0,0,0-18.93,2.88c-6,1.41-12.32,3.05-17.85,5.87-.37.19,0,.76.34.57Z"
          fill="#5b3f45"
        />
        <path
          d="M769.3,838.06q2-4.45,4.09-8.89c1.34-2.87,3.18-5.37,4.77-8.09,3.18-5.42,7.62-9.21,12.57-13,.33-.25,0-.82-.33-.57-4.66,3.55-9.21,7.18-12.25,12.27-1.65,2.75-3.57,5.37-5,8.26-1.53,3.2-3,6.44-4.46,9.66-.18.39.39.72.57.34Z"
          fill="#5b3f45"
        />
        <path
          d="M731.37,779.4A83.27,83.27,0,0,0,751,797.79c7.28,4.83,15.76,9.27,24.12,10a20.74,20.74,0,0,0,13.44-3.26,1.65,1.65,0,0,0,.47-2.07l-.9-1.9a1.54,1.54,0,0,0-2.19-.79c-6.15,3.79-15,2.53-21.56-.33a74,74,0,0,1-19.94-13,78.52,78.52,0,0,1-9.4-10.2c-2.13-2.74-5.81.45-3.68,3.2Z"
          fill="#382632"
        />
        <path
          d="M704.52,794.48a83.3,83.3,0,0,1-2.37,26.8c-2.2,8.46-5.57,17.42-11.34,23.49a20.7,20.7,0,0,1-12.19,6.54,1.66,1.66,0,0,1-1.74-1.23l-.6-2a1.56,1.56,0,0,1,1.11-2c7.11-1.27,12.85-8.09,15.85-14.62a73.76,73.76,0,0,0,6.2-23,78.15,78.15,0,0,0,.21-13.86c-.24-3.46,4.63-3.54,4.87-.07Z"
          fill="#382632"
        />
        <path
          d="M719.42,813.72a53.26,53.26,0,0,0-1.21-9.83,31.62,31.62,0,0,0-1.34-4.58,34.41,34.41,0,0,1-1.73-4.84c-.09-.41-.72-.23-.63.18a30.35,30.35,0,0,0,1.6,4.52,30.35,30.35,0,0,1,1.39,4.56,53.34,53.34,0,0,1,1.26,10c0,.42.68.43.66,0Z"
          fill="#5b3f45"
        />
        <g>
          <g>
            <polygon
              points="396.93 986.16 385.75 998.05 375.4 990.58 385.59 977.48 396.93 986.16"
              fill="#ffa18a"
            />
            <path
              d="M377.32,988.13c-2.52-2-17.54,10.84-17.1,14.34s4.63,8.48,7.41,13.71a56.41,56.41,0,0,0,9.74,13.26c4.64,4.53,9.89,7.82,13.51,4.56,9-8.14-5.11-23.8-2.05-33.7.56-1.83,2.28-5-.19-6.26-4.06-2-6.83,1.19-8.6-.18C376.61,991.24,377.32,988.13,377.32,988.13Z"
              fill="#f15931"
            />
          </g>
          <path
            d="M447.47,541.55c-.53-5.18-3.41-8.22-2.32-16.48,1-7.85,7.17-9.78,9.22-21,.4-2.21.61-4.62-.74-6.68-1.57-2.41-5.22-5.06-8.63-3.1-3.7,2.13-5.61,14.07-7.05,13.94-1.27-.11-1-9.51-2.77-9.7-2.42-.27-3.84,6.56-4,14.12a48.45,48.45,0,0,0,.7,11c1.88,13.16.87,16.95,1.35,22.07Z"
            fill="#ffa18a"
          />
          <path
            d="M293.44,535c.38-5.19,3.17-8.32,1.84-16.54-1.27-7.82-7.46-9.56-9.84-20.75-.46-2.2-.74-4.6.54-6.7,1.51-2.46,5.07-5.21,8.54-3.35,3.76,2,6,13.9,7.46,13.73,1.27-.15.68-9.53,2.48-9.79,2.42-.33,4,6.45,4.43,14a48.54,48.54,0,0,1-.37,11c-1.5,13.21-.37,17-.71,22.1Z"
            fill="#ffa18a"
          />
          <g>
            <polygon
              points="287.58 996.83 278.9 1010.65 267.3 1005.3 274.79 990.49 287.58 996.83"
              fill="#ffa18a"
            />
            <path
              d="M268.72,1002.53c-2.86-1.45-15.13,14-14,17.36s6.18,7.43,9.9,12a56.84,56.84,0,0,0,12.11,11.15c5.42,3.55,11.2,5.77,14.14,1.87,7.3-9.72-9.59-22.37-8.49-32.68.2-1.89,1.27-5.39-1.39-6.1-4.36-1.16-6.47,2.47-8.47,1.48C268.62,1005.72,268.72,1002.53,268.72,1002.53Z"
              fill="#f15931"
            />
          </g>
          <path
            d="M323.55,783.78c-6.48,11.9-20.42,127.32-62.13,207.24,0,0,28.85,17.34,33.44,11.63,29.44-36.6,65.27-193.32,81-193.89,7-.25,41.71,72.45,39.93,88.07-4.43,38.84-34.9,64.3-42.15,77.49,0,0,24,25,27.51,21.61,22.2-21.47,51.56-71.66,53.22-88.72C458,870,438,818.7,425.68,778.5Z"
            fill="#576949"
          />
          <path
            d="M292.05,522.82c.92-2.63,19.1-.11,18.94,3.78-.45,10.9-3.93,24.66-1.32,47.49s18.61,48.1,45.48,63.67l32.94,0c18.21-5.46,37.26-32.7,42.34-60.31,4.33-23.53-.42-36-.81-47.34-.06-1.74,16.12-4.4,17.66-.64,6.19,15.1,7.24,37.58,6.82,50.25-1.57,46.72-32.87,76.56-33,87.28-.33,36.56,20.85,115.23,22.91,146.14a19.85,19.85,0,0,1-12.65,5.51s-13-21.29-15.88-37.93L340,786c-5.63,18.08-13.62,29.42-13.62,29.42l-20.56-4.51c-5.51-40.52,23.91-115,18.08-149.08-2.08-12.14-31.88-29.67-38.69-82C284.51,574.56,286.24,539.46,292.05,522.82Z"
            fill="url(#New_Pattern_Swatch_3-19)"
          />
          <path
            d="M290.66,530.32c5,.28,10.2.77,14.57,3.45.4.24.76-.38.36-.63-4.47-2.74-9.8-3.26-14.93-3.54-.47,0-.47.7,0,.72Z"
            fill="#fffaf8"
          />
          <path
            d="M431.48,540.21a38.33,38.33,0,0,1,15-1.66c.46.05.46-.68,0-.72a38.92,38.92,0,0,0-15.16,1.68c-.44.14-.25.84.19.7Z"
            fill="#fffaf8"
          />
          <path
            d="M323.83,659.25a23.61,23.61,0,0,1,1.35-9.47,33.94,33.94,0,0,1,5.37-8.75c.29-.36-.22-.87-.51-.51a36,36,0,0,0-5.45,8.8,24,24,0,0,0-1.48,9.93c0,.46.74.46.72,0Z"
            fill="#fffaf8"
          />
          <path
            d="M323.78,659.43a22.73,22.73,0,0,1,2.81-4.43,12.26,12.26,0,0,1,4.19-3c.42-.2.05-.82-.37-.63a12.76,12.76,0,0,0-4.33,3.07,23.07,23.07,0,0,0-2.93,4.57c-.21.42.41.78.63.37Z"
            fill="#fffaf8"
          />
          <path
            d="M421.23,664.91c-.58-3-1.07-6.11-1.8-9.12a42.5,42.5,0,0,0-3.18-8.12c-.2-.42-.83,0-.63.37a41,41,0,0,1,3.18,8.26c.69,2.91,1.17,5.87,1.73,8.8.09.45.79.26.7-.19Z"
            fill="#fffaf8"
          />
          <g>
            <path
              d="M340,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-16.47,2.29-16.47-2.34c-4.84,11.17-10.79,35.82-7.21,62.64C355.15,754.36,340,786,340,786Z"
              fill="#fff"
            />
            <g clipPath="url(#clip-path-4)">
              <path
                d="M340,786a108.38,108.38,0,0,1,33.74,3c17,4.35,41.8-8.21,41.8-8.21-6.38-17.72-8.16-114.77-27.43-143l-32.94,0c-4.84,11.17-10.79,35.82-7.21,62.64C355.15,754.36,340,786,340,786Z"
                fill="#fff"
              />
              <rect
                x={345.11}
                y={673.5}
                width={56.78}
                height={3.98}
                fill="#f15931"
              />
              <rect
                x={346.34}
                y={684.88}
                width={56.92}
                height={3.98}
                fill="#f15931"
              />
            </g>
          </g>
          <path
            d="M360.27,619.76V633a3.81,3.81,0,0,1-1.6,3.09c-2.48,1.77-3.52,1.66-3.52,1.66s4.26,8,16.47,8c14.05,0,16.47-8,16.47-8a7.53,7.53,0,0,1-4.6-1.53,3.21,3.21,0,0,1-1.2-2.6l.1-13.92Z"
            fill="#ffa18a"
          />
          <path
            d="M382.35,625.82c-3.4,3.85-15,4.79-22.08,0v-4.1h22.11Z"
            fill="#ff7a5a"
            opacity={0.4}
          />
          <path
            d="M392,596.27l-.42,0,1-7.78c1.34-13.53-9.94-20.34-21-20.36h0c-10.07,0-19.53,3.81-20.82,16.05a26.61,26.61,0,0,0,0,5.5l.68,6.48h-.18a4.4,4.4,0,0,0,0,8.79,1.71,1.71,0,0,0,.32,0c.18,11.6,4.44,21.28,19.61,21.91h0c13.49,0,19.9-9.15,20.16-21.84a3.64,3.64,0,0,0,.57,0,4.4,4.4,0,0,0,0-8.79Z"
            fill="#ffa18a"
          />
          <g>
            <path
              d="M393.55,598.79a3.1,3.1,0,0,0-1.12,1.39,3.69,3.69,0,0,0-.12,2c0,.24.41.14.38-.1a3.31,3.31,0,0,1,.1-1.71,2.68,2.68,0,0,1,1-1.2c.2-.15,0-.48-.2-.33Z"
              fill="#ff7a5a"
            />
            <path
              d="M392.66,600.61a1.66,1.66,0,0,1,.32,0h.12l.14,0,.06,0h0l.11.06,0,0s0,0,0,0l0,0,.09.08v0s0,0,0,0l0,0,.06.1v0h0l0,0,0,.11s0,0,0,.06,0,0,0,0v.22s0,0,0,0v0s0,0,0,.07a.56.56,0,0,1,0,.12s0,0,0,.05,0,0,0,0a.41.41,0,0,1-.07.11l0,0h0l0,0a.19.19,0,0,0,0,.27.2.2,0,0,0,.28,0,1.31,1.31,0,0,0,.32-1.07,1.09,1.09,0,0,0-.71-.84,1.8,1.8,0,0,0-.86-.06.19.19,0,0,0-.14.24c0,.11.13.14.24.13Z"
              fill="#ff7a5a"
            />
          </g>
          <g>
            <path
              d="M349.52,599.05a2.74,2.74,0,0,1,1,1.21,3.31,3.31,0,0,1,.1,1.71c0,.24.34.35.38.1a3.7,3.7,0,0,0-.11-2,3.18,3.18,0,0,0-1.12-1.4c-.2-.14-.4.19-.2.33Z"
              fill="#ff7a5a"
            />
            <path
              d="M350.71,600.18a1.47,1.47,0,0,0-1.31.35,1.15,1.15,0,0,0-.25,1.05,1.31,1.31,0,0,0,.3.57.19.19,0,0,0,.27,0,.18.18,0,0,0,0-.27s0-.06,0,0l0,0-.06-.1,0-.05v0s0,0,0,0,0-.07,0-.11a.36.36,0,0,1,0-.11s0-.06,0,0v0a.4.4,0,0,1,0-.11v0s0-.08,0,0a.73.73,0,0,1,.06-.21s0,0,0,0l0-.05a.47.47,0,0,1,.06-.09s0,0,0,0l0,0,0,0,0,0s0,0,0,0l.1-.05.05,0h0s0,0,0,0l.14,0h.14a2.14,2.14,0,0,1,.36,0,.21.21,0,0,0,.25-.13.21.21,0,0,0-.14-.24Z"
              fill="#ff7a5a"
            />
          </g>
          <path
            d="M382.49,558.15c1.84-2.36,5.51-2.23,8.05-1.13,3,1.32,2.41,5.22,1.91,7.86-.24,1.34.91,3.06,2.47,2.46a5.32,5.32,0,0,1,6.73,2.45,5.41,5.41,0,0,1-2.22,6.73,2,2,0,0,0,0,3.45c2.49,1.27,5.82,2.88,6.81,5.73,1.17,3.37-2.08,6.35-4.27,8.41a2,2,0,0,0,0,2.83,8.4,8.4,0,0,1,1.59,10.33,10.36,10.36,0,0,1-10.3,4.64l1.39,2.46a17.6,17.6,0,0,0-.33-7.74l-.92,2.26c4-1.78,7.35-5.62,6.44-10.27a6.56,6.56,0,0,0-3.57-4.72,18,18,0,0,0-2.57-.85c-.29-.09-1.16-.22-1.24-.59s.43-1,.58-1.34a13.14,13.14,0,0,0,.67-1.48,9,9,0,0,0,.6-3.33,7.07,7.07,0,0,0-3.1-5.79c-1.83-1.36-2.23-3.67-3.51-5.47a12.92,12.92,0,0,0-19.38-2.13h2.83c-2.47-2.55-6.29-3.74-9.57-2a6.57,6.57,0,0,0-3.17,3.86c-.47,1.59-.06,3.17-.22,4.77-.13,1.33-1.67,1.48-2.69,2a4.93,4.93,0,0,0-2.87,3.78c-.25,1.62.31,3.31-.18,4.89a4.69,4.69,0,0,1-2.49,2.85c-1.74.77-3.51.87-5,2.25a7,7,0,0,0-2.1,4.46,6.88,6.88,0,0,0,1.65,4.87,6.46,6.46,0,0,0,2,1.58,7.56,7.56,0,0,1,2.05,1,1.71,1.71,0,0,1-.24,2.56,4.31,4.31,0,0,1-3.38.1,13.7,13.7,0,0,1-7.18-5.48,10.65,10.65,0,0,1-1.62-9.4c1-2.86,3.45-5.62,6.58-6,1.31-.16,2.74-1.65,1.72-3-1.86-2.51-3.55-6.44-1.3-9.26a4.22,4.22,0,0,1,3.19-1.71,13.79,13.79,0,0,1,2,.46,3.14,3.14,0,0,0,2.76-.8c1.24-1.19,1-3,.8-4.48a5.94,5.94,0,0,1,.92-4.24c1.86-2.72,5.46-2.8,7.93-.91,1.31,1,2.9-.4,3-1.72.06-.87.05-2.21.76-2.83.49-.42.51-.29.88.2a14.39,14.39,0,0,0,1.76,2.33,5.4,5.4,0,0,0,3.2,1.29c2.25.18,4.48-.83,6.45-1.78a30.89,30.89,0,0,0,6.24-4.11c2-1.65-.86-4.47-2.83-2.83a26.24,26.24,0,0,1-6.54,4,6.55,6.55,0,0,1-3.14.75c-.9-.12-1.23-1-1.69-1.66-1.38-2-3.58-3.13-5.93-1.91s-3,4-3.16,6.56l3-1.73a9.41,9.41,0,0,0-11.66.34,9.6,9.6,0,0,0-3.05,5.11,9.37,9.37,0,0,0-.19,3c.05.43.15.86.2,1.28q0,.32,0,.63c.06.39.38.25,1-.42-.07-.17-1.16-.36-1.36-.41a6.91,6.91,0,0,0-4.4.55,8.77,8.77,0,0,0-4.12,3.86c-2.13,4.06-.75,8.95,1.84,12.44l1.73-3c-7,.83-11.85,7.76-11,14.67s6.88,13.51,13.82,14.38c3.43.43,7.05-1.3,7.42-5.06a5.85,5.85,0,0,0-1.65-4.65c-1.2-1.17-3.23-1.27-4.09-2.77A2.78,2.78,0,0,1,348,598a7.25,7.25,0,0,1,2.44-.9,8.3,8.3,0,0,0,2.63-1.26,8.94,8.94,0,0,0,3.18-4.26c.63-1.8.23-3.45.33-5.28.09-1.59,2.21-1.65,3.32-2.38a5.68,5.68,0,0,0,2.35-5.17c0-1.66-.39-3.51,1.4-4.38s3.51.11,4.72,1.36a2,2,0,0,0,2.83,0,8.93,8.93,0,0,1,9.77-1.4,9.21,9.21,0,0,1,3.74,3.34c1,1.69,1.54,3.69,3,5.11,1.28,1.23,2.65,1.69,2.63,3.69s-1.3,3.18-1.71,4.91a4.24,4.24,0,0,0,2.15,4.78c1.27.68,2.94.67,4.11,1.48s1.4,2.74.88,4c-.76,1.86-2.61,3-4.36,3.75a2,2,0,0,0-.92,2.26,12.83,12.83,0,0,1,.34,5.61,2,2,0,0,0,1.39,2.46c5.68.86,11.84-1.33,14.82-6.47,2.77-4.78,2-11.48-2.21-15.18v2.83c3.27-3.09,6.71-7.14,5.39-12-1.12-4.14-5.15-6.61-8.74-8.43V580a9.44,9.44,0,0,0,3.79-11.9,9.28,9.28,0,0,0-11.39-4.59l2.46,2.46c.84-4.52,1.06-10.18-3.87-12.43-4-1.8-9.86-1.93-12.78,1.81a2.07,2.07,0,0,0,0,2.83,2,2,0,0,0,2.83,0Z"
            fill="#8f493b"
          />
          <path
            d="M349.63,556.23a1,1,0,0,1-.14.43c.11-.19.1-.18-.05,0s-.22.15,0,0c-.2.07-.18.06,0,0l.37-.08c-.21,0-.2,0,0,0l.72,0c.41,0,.83,0,1.24.07.24,0,.24,0,0,0l.35.06c.24,0,.47.09.7.15a13.44,13.44,0,0,1,1.37.41s.58.23.18.06c.22.09.44.2.65.3a11.62,11.62,0,0,1,1.23.72c.2.13.4.26.59.41-.34-.26.23.2.29.24a2,2,0,1,0,2.82-2.82,14.33,14.33,0,0,0-6.94-3.36,13.21,13.21,0,0,0-4.21-.09,3.66,3.66,0,0,0-3.23,3.47,2,2,0,0,0,4,0Z"
            fill="#8f493b"
          />
          <g>
            <path
              d="M392,596.27l-.42,0,0-.29H351.5v.18h-.18a4.4,4.4,0,0,0,0,8.79,1.71,1.71,0,0,0,.32,0c.18,11.6,4.44,21.28,19.61,21.91,13.49,0,19.9-9.15,20.16-21.84a3.64,3.64,0,0,0,.57,0,4.4,4.4,0,0,0,0-8.79Z"
              fill="#ffa18a"
            />
            <g>
              <path
                d="M393.29,598.38a3.07,3.07,0,0,0-1.13,1.39,3.69,3.69,0,0,0-.12,2c0,.24.42.14.38-.1a3.3,3.3,0,0,1,.11-1.71,2.61,2.61,0,0,1,1-1.2c.2-.15,0-.48-.19-.33Z"
                fill="#ff7a5a"
              />
              <path
                d="M392.39,600.2a1.71,1.71,0,0,1,.32,0h.12l.14,0,.06,0h0l.11.06.05,0s0,0,0,0l0,0a.3.3,0,0,1,.08.08l0,0h0l0,0,.06.1v0s0,0,0,0a.43.43,0,0,0,0,0,.23.23,0,0,1,0,.11.13.13,0,0,1,0,.06h0a.49.49,0,0,1,0,.12s0,.06,0,.1,0,0,0,0v0a.64.64,0,0,0,0,.07l0,.12,0,0s0,0,0,0l-.06.11,0,0h0l0,0a.19.19,0,0,0,0,.27.2.2,0,0,0,.28,0,1.32,1.32,0,0,0,.32-1.07,1.07,1.07,0,0,0-.71-.84,1.67,1.67,0,0,0-.86-.06c-.11,0-.16.15-.14.24a.2.2,0,0,0,.24.13Z"
                fill="#ff7a5a"
              />
            </g>
            <g>
              <path
                d="M349.25,598.64a2.62,2.62,0,0,1,.95,1.21,3.31,3.31,0,0,1,.1,1.71c0,.24.34.34.38.1a3.69,3.69,0,0,0-.11-1.95,3.18,3.18,0,0,0-1.12-1.4c-.2-.15-.39.19-.2.33Z"
                fill="#ff7a5a"
              />
              <path
                d="M350.44,599.77a1.45,1.45,0,0,0-1.31.35,1.18,1.18,0,0,0-.25,1,1.43,1.43,0,0,0,.3.57.2.2,0,0,0,.28,0,.19.19,0,0,0,0-.27s0-.06,0,0l0,0-.06-.1,0,0v0s0,0,0,0a.49.49,0,0,1,0-.11l0-.11s0-.06,0,0,0,0,0,0v-.16s0-.08,0,0l.06-.2s0,0,0,0,0,0,0,0l.06-.09,0,0,0,0,0,0,0,0h0l.09,0,0,0h0l.15,0H350a2.26,2.26,0,0,1,.37,0,.2.2,0,0,0,.24-.13.2.2,0,0,0-.14-.24Z"
                fill="#ff7a5a"
              />
            </g>
          </g>
          <path
            d="M371.1,603.3c-.2.82-.45,1.63-.7,2.44a10.12,10.12,0,0,0-.45,1.72,1.21,1.21,0,0,0,.25,1.07,1.86,1.86,0,0,0,1.38.41,2.36,2.36,0,0,0,1.75-1.15c.15-.23-.22-.44-.36-.21a1.85,1.85,0,0,1-1.78.94c-.44-.06-.83-.25-.84-.72a5.79,5.79,0,0,1,.39-1.73c.27-.88.55-1.76.77-2.65.06-.26-.35-.38-.41-.12Z"
            fill="#ff7a5a"
          />
          <path
            d="M371.43,615.56c2.69.16,4.44-.82,5.07-1.63a.23.23,0,0,0-.17-.36s-2.92,0-4.79-.1-4.78-.5-4.78-.5c-.18,0-.27.06-.18.21C367,614.06,368.55,615.38,371.43,615.56Z"
            fill="#fff"
          />
          <path
            d="M366.46,590.88c.43-.69.13-1.11-1-1.53a8.68,8.68,0,0,0-3.57-.35c-2.44.31-3.85,2.19-3.14,1.93a9.79,9.79,0,0,1,4.62-.49C364.7,590.52,366.18,591.34,366.46,590.88Z"
            fill="#824237"
          />
          <path
            d="M375.75,590.88c-.42-.69-.13-1.11,1-1.53a8.75,8.75,0,0,1,3.58-.35c2.43.31,3.85,2.19,3.13,1.93a9.75,9.75,0,0,0-4.61-.49C377.52,590.52,376,591.34,375.75,590.88Z"
            fill="#824237"
          />
          <g>
            <g>
              <path
                d="M403.38,594.54c2.57-2.41,5.35-5.34,5.09-8.87-.3-4.07-4.41-6.58-8-8.41a7.4,7.4,0,0,0,3-9.31,7.31,7.31,0,0,0-9.07-3.52c.61-3.18,1-7-1.36-9.16a7.47,7.47,0,0,0-3.4-1.59c-3-.72-6.71-.44-8.54,2.08l.56.31c-.54.45-1.1.88-1.67,1.29a3,3,0,0,0-.32.12l-.7-.62A13.43,13.43,0,0,0,368.87,550a10.7,10.7,0,0,0-10.49,5.63,19.53,19.53,0,0,0-9.84-1.82,4.85,4.85,0,0,0-2.06.5,4.25,4.25,0,0,0-1.55,1.73,7.86,7.86,0,0,0,0,7.13,10.91,10.91,0,0,0-7.88,8c-.46,2-.6,4.56.59,6.3a7.77,7.77,0,0,0-1.11,1.32,5.3,5.3,0,0,0-1,3.92c.37,2.15,2.57,3.43,4.52,3.84a2.22,2.22,0,0,0,.51.06,11.44,11.44,0,0,0-6.89,11c.3,5.42,4.19,10.21,9,12.57,2.54,1.24,6.11,1.65,7.74-.67a3.77,3.77,0,0,0-1-5.11c-.65-.42-1.4-.61-2.08-1a4.76,4.76,0,0,1,.18-8.46c.93-.46,2-.59,3-1a6.64,6.64,0,0,0,4.15-6c0-1.62-.51-3.45.48-4.74s3.19-1.29,4.31-2.57c1.39-1.6.35-4.13.85-6.19a4.76,4.76,0,0,1,4.27-3.41,6.62,6.62,0,0,1,5.18,2.24,10.89,10.89,0,0,1,17,3c.74,1.39,1.21,3,2.34,4.06.59.55,1.31.93,1.88,1.49,1.76,1.72,1.63,4.68.53,6.88-.53,1.05-1.27,2.16-1,3.3.53,1.91,3.22,1.81,5,2.69,2.21,1.09,3,4.13,2.13,6.46a9.27,9.27,0,0,1-5.28,4.94,14.35,14.35,0,0,1,.33,6.67,12.42,12.42,0,0,0,12.39-5.26C407.65,603.53,407,597.6,403.38,594.54Zm-62.57-19.41h0l0,0S340.81,575.15,340.81,575.13Zm.85,11.09a.41.41,0,0,0,.11-.07,2.29,2.29,0,0,0,.57-.66c.13.18.25.37.39.55A9.18,9.18,0,0,0,341.66,586.22Z"
                fill="#8f493b"
              />
              <polygon
                points="351.03 595.64 351.51 596.18 352.36 596.44 352.79 596 352.08 594.96 351.03 595.64"
                fill="#8f493b"
              />
              <polygon
                points="390.48 596 390.94 596.44 391.56 596.29 392.23 595.48 391.18 594.96 390.48 596"
                fill="#8f493b"
              />
            </g>
            <path
              d="M378.5,559.29s-7.64.91-8.57,12.06"
              fill="none"
              stroke="#bf665a"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={0.5}
            />
            <path
              d="M391.44,609.83c-.55,3.83-3.51,8.45-6.29,11.06-1.4,1.31-2.61,2.42-2.45,4.49a4.21,4.21,0,0,0,3.39,3.8c7.26,1.89,20.94-6.08,14.46-14.24-1.15-1.44-3.78-1.26-4.95,0l-1.77,1.9,5.85,3.41a11.09,11.09,0,0,1,2.72-4.06c3.21-3.18-1.67-8-4.95-5a104.69,104.69,0,0,0-8.73,9.26c-2.86,3.44,2.06,8.42,4.95,5a104.69,104.69,0,0,1,8.73-9.26l-4.95-5a19.26,19.26,0,0,0-4.52,7.15c-1.23,3.31,3.56,5.87,5.85,3.4l1.77-1.9H395.6c-.61-.77-.18-.63-1.13.13a11.84,11.84,0,0,1-2.21,1.34,10.4,10.4,0,0,1-2.09.81c-1,.26-2.58-.19-1.49.73l1,2.48c-.55,1.11-.54,1.36,0,.77a7.2,7.2,0,0,0,.71-.64,18.64,18.64,0,0,0,1.58-1.74,27.62,27.62,0,0,0,2.64-3.88c1.37-2.42,3.13-5.41,3.53-8.2.63-4.4-6.11-6.31-6.75-1.86Z"
              fill="#8f493b"
            />
            <path
              d="M339.1,607.16c-4.67,3.2-4.06,9.7-.15,13.34,4.52,4.2,11.95,6.46,17.65,8.58,3.93,1.46,5.75-4.28,2.69-6.4-3.63-2.52-5.62-6.66-7.25-10.64-1.36-3.28-5.41-3.33-6.75,0a13.91,13.91,0,0,1-1.47,3.09l3-1.73c.8.25.8.14,0-.32l-1.73-1.34c-3.56-2.74-7.05,3.33-3.53,6,1.92,1.48,4,3.44,6.59,2.31,2.32-1,3-4.08,3.85-6.2h-6.75c2.4,5.83,5.17,11.15,10.47,14.82l2.7-6.39c-3.1-1.16-6.15-2.42-9.13-3.87-.85-.41-8.25-4.19-6.7-5.25,3.69-2.53.2-8.6-3.53-6.05Z"
              fill="#8f493b"
            />
          </g>
          <path
            d="M385.61,629.56c4.51,0,4.52-7,0-7s-4.51,7,0,7Z"
            fill="#8f493b"
          />
          <ellipse cx={363.5} cy={600} rx={1} ry={2} fill="#564444" />
          <ellipse cx={379.5} cy={600} rx={1} ry={2} fill="#564444" />
        </g>
        <circle cx={428.31} cy={291.81} r={0.94} fill="#26211d" />
        <circle cx={410.44} cy={291.81} r={0.94} fill="#26211d" />
        <path
          d="M575.17,569.54c13.48-30.35,13.54-37.75,20.24-41.46,8-4.43,17.19-4.87,20.94-5.15,1.08-.08,5.61,0,5.61,0,4.24.41,19.21-.09,19.86,2.52.2.78-1.12,1.27-1.12,1.27.83,0,1.62.82.77,1.74a5.51,5.51,0,0,1-1.56.94c.74,3.35-6.86,3.94-15.83,6.31-16.4,4.33-18.44,1.33-21.54,3.57-3.49,2.52-6.92,28.15-11.93,36.17Z"
          fill="#d69b6d"
        />
        <g>
          <path
            d="M743.86,514.41c9.73-31.75,8.89-39.1,15.1-43.59,7.4-5.36,17.08-5.48,20.16-7.64.53-.37,5.46-8.51,6.8-8.17,1.94.49.43,3.3,0,4.89a10.56,10.56,0,0,1-1.17,2.91c4.26-.11,19-2.72,20-.21.29.76-.42,2.22-.42,2.22.82-.11,2-.53,2.37.26,1,2.11-7.13,5.39-18.32,9.84-15.77,6.29-18.15,3.55-21,6.15-3.16,2.92-3.47,28.78-7.48,37.35Z"
            fill="#d69b6d"
          />
          <path
            d="M760.24,485.7q1.1-2.19,2.21-4.37a42.4,42.4,0,0,0,2-4.25c.15-.4-.49-.57-.64-.17a43.39,43.39,0,0,1-2,4.24l-2.13,4.22c-.19.37.38.71.57.33Z"
            fill="#bc835a"
          />
          <path
            d="M762,475a4.46,4.46,0,0,0,5,2.84c1.53-.25,3-.77,4.57-1.1A29.43,29.43,0,0,0,776,475.5a11.9,11.9,0,0,0,5.6-5c1.48-2.28,3.06-4.47,3.5-7.22.07-.41-.56-.59-.63-.17a15.9,15.9,0,0,1-2.8,6.06c-1.33,2.08-2.65,4-4.88,5.26s-4.64,1.44-7,2c-1.31.3-2.69.91-4,.78a3.76,3.76,0,0,1-3.11-2.41c-.16-.39-.8-.22-.64.18Z"
            fill="#bc835a"
          />
          <path
            d="M803.72,464.75a12,12,0,0,1-3.78,1.84c-1.26.49-2.47,1.09-3.7,1.66a42.48,42.48,0,0,1-8.66,2.72c-.42.09-.24.73.17.63a43.34,43.34,0,0,0,8.83-2.78c1.41-.65,2.8-1.32,4.27-1.86a9.94,9.94,0,0,0,3.33-1.75c.32-.28-.14-.74-.46-.46Z"
            fill="#bc835a"
          />
        </g>
        <g>
          <path
            d="M654.5,626.35c-10-4.1-16.3-2.31-21.07-3.79-8.07-2.51-39.59-20.38-40.64-29.69-1.63-14.42,4.44-28.64,4.44-28.64-10.22.47-20.17-5.69-20.17-5.69-8.53,13.6-12.19,33.18-11.37,39.59,4.84,37.91,72.45,55.82,76.17,64.66,8.87,21.07,26.16,34.49,25.06,55.81-.72,14.08-3,19.71-9,46.47-4.15,18.71,0,19.7.51,32.39a2.08,2.08,0,0,0,2,2c5.5.22,23.78-.13,68.26-9.12a90.56,90.56,0,0,0,30.61-12.64c-.89-7.21-5.09-15.86-9-26.15-10.11-26.64-8.8-35.44-18.39-87.25-3.69-20-1.79-19.77-1.55-25,.42-9,10.78-42.93,19.94-68.27,10.17-28.12,13.9-59,13.9-59-8.84,2.18-19.8-5-19.8-5-14.55,15.51-18.11,67.11-33.13,92.67Z"
            fill="#13a89e"
          />
          <g clipPath="url(#clip-path-5)">
            <g>
              <rect
                x={740.92}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={740.92}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={740.92}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={740.92}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={740.92}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={740.92}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={740.92}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={740.92}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={623.24}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={623.24}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={623.24}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={623.24}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={623.24}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={623.24}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={623.24}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={623.24}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={505.56}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={505.56}
                y={474.76}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={505.56}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={505.56}
                y={568.19}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={505.56}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={505.56}
                y={661.61}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
            <g>
              <rect
                x={505.56}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="none"
              />
              <rect
                x={505.56}
                y={755.03}
                width={117.68}
                height={93.42}
                fill="#13a89e"
              />
            </g>
          </g>
        </g>
        <g>
          <path
            d="M654.6,616.55c4-2.17,9.74-3.71,12.25-5.57s4.06-3.61,3.73-6.32l-2-16.06c-1.78-1.55-7.56-13.39-7.37-21.5.41-17.3,11-32.29,24.87-33.19,16-1,24.94,11.72,26.56,29l.1,1.19a57.32,57.32,0,0,1-5.69,19.6c-3.21,6.78-9.93,12.65-12.65,13.29l.63,4.92a6.1,6.1,0,0,0,5.27,5.22c3.51.5,9,.5,14.61,1.36a15.92,15.92,0,0,1,9.52,5.24l-.06.07a1.46,1.46,0,0,1-.16.19.3.3,0,0,1-.08.08l0,0,0,0a.22.22,0,0,0-.06.23c-1.21,2.87-3.68,24.62-28.89,29.1C669.1,648.05,643.87,622.39,654.6,616.55Z"
            fill="#d69b6d"
          />
          <path
            d="M694.53,564.29c.51-.68.34-1-.73-1.57a8.76,8.76,0,0,0-3.58-.69c-2.53,0-5,1.68-4.23,1.5a13.45,13.45,0,0,1,5.48-.27C692.81,563.47,694.41,564.44,694.53,564.29Z"
            fill="#513715"
          />
          <path
            d="M702.28,565.19c-.49-.69-.34-1.05.61-1.53a7.27,7.27,0,0,1,3.23-.57c2.3.13,4.6,1.82,3.89,1.62a11.37,11.37,0,0,0-5-.44C703.81,564.44,702.39,565.35,702.28,565.19Z"
            fill="#513715"
          />
          <path
            d="M699.3,573.07c.14.71.33,1.42.52,2.13a9.55,9.55,0,0,1,.33,1.5,1.08,1.08,0,0,1-.24.92,1.5,1.5,0,0,1-1.17.32,2,2,0,0,1-1.45-1c-.11-.2.2-.38.31-.18a1.56,1.56,0,0,0,1.48.87c.37,0,.7-.2.72-.6a4.92,4.92,0,0,0-.28-1.52c-.2-.77-.41-1.53-.57-2.32,0-.22.3-.31.35-.08Z"
            fill="#bc835a"
          />
          <path
            d="M694.69,598.8l-.24-1.86c-10.75,2.8-17.64-11.28-17.64-11.28C681.69,595.52,684.1,600.08,694.69,598.8Z"
            fill="#9e695c"
            opacity={0.2}
            style={{
              mixBlendMode: "multiply",
            }}
          />
          <path d="M667.13,568.62Z" fill="#ff7a5a" />
          <path
            d="M697.13,584.16c-2.37-.21-3.79-1-4.24-1.62-.08-.1,0-.22.18-.2,0,0,2.55.36,4.19.5s4.24.25,4.24.25c.16,0,.22.06.13.15C701.13,583.74,699.66,584.38,697.13,584.16Z"
            fill="#fff"
          />
          <g>
            <path
              d="M708.26,572.08a4.21,4.21,0,0,0-4.44-.2c-.35.19-.62-.35-.27-.54a4.85,4.85,0,0,1,5.06.24c.33.22,0,.72-.35.5Z"
              fill="#382632"
            />
            <path
              d="M693,571a4.21,4.21,0,0,0-4.44-.2c-.35.19-.62-.35-.27-.54a4.85,4.85,0,0,1,5.06.24c.33.22,0,.72-.35.5Z"
              fill="#382632"
            />
          </g>
          <path
            d="M690,625.42c-.83-1.28-2.59-1-3.86-.73s-2.83.64-4.22,1.06c-.38.12-.55-.49-.16-.61a35.94,35.94,0,0,1,5-1.2c1.37-.21,2.94-.12,3.77,1.16.22.35-.33.66-.55.32Z"
            fill="#894e46"
          />
          <path
            d="M694.23,624.69c0-1.43.16-3.07,1.36-4a.32.32,0,1,1,.45.45c-1.08.86-1.14,2.32-1.18,3.59a.32.32,0,0,1-.63,0Z"
            fill="#894e46"
          />
        </g>
        <path
          d="M642.33,661.75c1.13-3.65,3.5-6.78,4.84-10.36A67.86,67.86,0,0,0,650,639.71c.07-.41-.56-.59-.64-.17a66.62,66.62,0,0,1-2.82,11.67c-1.33,3.59-3.7,6.71-4.84,10.37a.33.33,0,0,0,.64.17Z"
          fill="#19bcac"
        />
        <path
          d="M639.87,660.06a15.53,15.53,0,0,0,.84-9.79c-.1-.41-.73-.24-.63.18a14.78,14.78,0,0,1-.78,9.28c-.16.39.4.72.57.33Z"
          fill="#19bcac"
        />
        <path
          d="M592.28,593.61a17.29,17.29,0,0,1-7.77,9.66.33.33,0,0,0,.34.57,18,18,0,0,0,8.07-10.05c.13-.41-.51-.58-.64-.18Z"
          fill="#19bcac"
        />
        <path
          d="M574.29,564.55l5.2,2.15a37.54,37.54,0,0,0,4.76,1.81,69.86,69.86,0,0,0,10.38,1.64c.43,0,.42-.62,0-.66a61.71,61.71,0,0,1-10.55-1.71,94.69,94.69,0,0,1-9.62-3.87c-.39-.16-.56.48-.17.64Z"
          fill="#19bcac"
        />
        <path
          d="M738,518a15.21,15.21,0,0,0,4.93,2.33c2.08.74,4.21,1.36,6.35,1.92s4.31,1,6.48,1.51a27.82,27.82,0,0,0,6.07,1,.33.33,0,0,0,0-.66,29,29,0,0,1-6.33-1c-1.87-.41-3.75-.83-5.61-1.31s-3.71-1-5.53-1.6-4.35-1.24-5.89-2.59c-.32-.28-.79.19-.47.47Z"
          fill="#19bcac"
        />
        <path
          d="M658.59,792.52c16.81,1.79,33.19-2.37,49.62-5.31s33.44-6.34,48.53-14.13c.37-.2,0-.77-.34-.57-15,7.76-31.85,11.12-48.36,14.07s-32.73,7.06-49.45,5.28c-.42-.05-.42.61,0,.66Z"
          fill="#19bcac"
        />
        <path
          d="M600.26,531.76a6,6,0,0,0,1.35,7.53c.32.27.79-.19.46-.47a5.33,5.33,0,0,1-1.24-6.72c.21-.37-.36-.71-.57-.34Z"
          fill="#bc835a"
        />
        <path
          d="M639.45,529.27a17.23,17.23,0,0,0-5.12,0c-1.77.18-3.54.36-5.3.56-3.56.42-7.11.92-10.62,1.61-.42.09-.24.72.17.64,3.46-.68,6.95-1.18,10.45-1.59,1.63-.18,3.26-.36,4.89-.52a17.77,17.77,0,0,1,5.35,0c.42.08.59-.56.18-.64Z"
          fill="#bc835a"
        />
        <path
          d="M640.4,526.28c-3.41-1-6.64-.67-10.09-.27-2.78.32-5.56.7-8.35,1-.42,0-.43.7,0,.66,2.72-.25,5.43-.61,8.15-.93,3.45-.4,6.69-.81,10.12.22.4.13.58-.51.17-.63Z"
          fill="#bc835a"
        />
        <path
          d="M616.71,524.85a13.31,13.31,0,0,1,3.19-.66l3.24-.27c.42,0,.43-.69,0-.66l-3.37.28a13.65,13.65,0,0,0-3.23.67c-.4.14-.23.77.17.64Z"
          fill="#bc835a"
        />
        <path
          d="M609.53,524.52c-.25-.73.92-1.5,2.18-3.73,1.09-1.95,1.29-3,2-3.18s1.31.53,1.48,1.42-.18,1.33-.92,3.07-.57,2.28-1.15,2.74C612,525.73,609.8,525.33,609.53,524.52Z"
          fill="#d69b6d"
        />
        <path
          d="M610.43,523.75a13,13,0,0,1,3.17-.39.33.33,0,0,0,0-.66,13.55,13.55,0,0,0-3.35.42.33.33,0,0,0,.18.63Z"
          fill="#bc835a"
        />
        <path
          d="M653.59,622.78s28,3,37-4.22,9.75-11.48,9.75-11.48l30.92,3.12-6.79,24.69s-29.23,31.43-29.3,30.87-46.66-32.53-46.66-32.53Z"
          fill="#13a89e"
        />
        <path
          d="M635.11,622.94l19.67-5.78s-6.77,6.37,19.92,3.4,27.59,3.29,27.59,3.29l-17.47,20.24Z"
          fill="#13a89e"
        />
        <g clipPath="url(#clip-path-6)">
          <g>
            <rect
              x={623.24}
              y={568.19}
              width={117.68}
              height={93.42}
              fill="none"
            />
            <rect
              x={623.24}
              y={568.19}
              width={117.68}
              height={93.42}
              fill="#13a89e"
            />
          </g>
        </g>
        <path
          d="M706.29,591a43.81,43.81,0,0,1-7,6.29,3.07,3.07,0,0,0-1.07,4.1,3,3,0,0,0,4.1,1.08,50.26,50.26,0,0,0,8.25-7.23c2.6-2.85-1.63-7.1-4.24-4.24Z"
          fill="#dbc3a1"
        />
        <path
          d="M699.45,541.39l-5.89,3,2.72,4.65c3-1.77,6.59-3.21,8.45-6.21a2.73,2.73,0,0,0-2.33-4.06c-7.72,0-15.37,4-22.84,5.66l2.62,4.51,1.58-2c2.1-2.71-1.69-6.55-3.81-3.81l-1.58,2.05c-1.6,2.07-.19,5.12,2.62,4.5,6.9-1.51,14.31-5.5,21.41-5.47l-2.33-4c-1.12,1.8-4.7,3.19-6.51,4.28-3,1.81-.36,6.22,2.72,4.65l5.89-3c3.09-1.56.37-6.22-2.72-4.65Z"
          fill="#dbc3a1"
        />
        <path
          d="M721.63,551.76c-.84-10.44-10.31-20.49-20.88-16.84a21.58,21.58,0,0,0-35,1.35,54.74,54.74,0,0,1-3.3,5.05c-1.29,1.49-3.07,2.26-4.45,3.62-2.51,2.45-2.42,5.56-2,8.81.33,2.58.63,4.56-1.13,6.74-1,1.23-2.23,2.23-3.16,3.52a7.54,7.54,0,0,0-1.2,7.57c1,2.61,1.67,3.27.58,6.23-.49,1.33-1.3,2.56-1.72,3.93a9.34,9.34,0,0,0-.37,4.42c.54,3.06,1.52,4.32,0,7.34-3.28,6.5-.8,10,5.94,11.76l.86.23a16.53,16.53,0,0,0,8.5,2.32,51.55,51.55,0,0,0,5.12,1c3,.41,5.88-.08,7.78-2.57,2.08-2.74,2.16-6.93,2.29-10.23a45.84,45.84,0,0,0-.31-7.13,20.77,20.77,0,0,1,.44-7.12c.35-2.09-.4-3.19-1.06-5.08-.95-2.73.4-3.55,1.74-5.7a9.18,9.18,0,0,0,1.54-4c.16-1.85-.9-3-1.18-4.66-.66-3.79,3.31-3.73,5.9-4.41,2.21-.58,4.44-1.13,6.61-1.86a28.35,28.35,0,0,0,10.61-6c.93,1.5,2,2.95,3.14,4.39,4.44,5.83,5.14,11.67,3.57,18.8a38,38,0,0,1-9.33,17.79c-2.88,3.06-9,6.41-6.78,11.5,1.72,3.89,6.67,3.25,9.79,1.48,4.88-2.77,7.08-8.15,8.14-13.38A129.33,129.33,0,0,1,718,570.56C720.18,564.56,722.15,558.24,721.63,551.76Zm-6,6.94a1.55,1.55,0,0,0,.31,0c0,.22-.08.43-.12.64C715.71,559.1,715.65,558.9,715.58,558.7Zm-14.87-13.13a18,18,0,0,1-3.36,2.68,4.2,4.2,0,0,0-1.91-4.09,17.6,17.6,0,0,1,3.39-1.52,4.22,4.22,0,0,0,2.41-2.1,7.59,7.59,0,0,1,.77-.35,3.34,3.34,0,0,0-.48,1.32,10.78,10.78,0,0,0,.11,3.42A2.73,2.73,0,0,0,700.71,545.57Zm.73,53.83c-2.3,1-1.31.09-.05-1.15,1.69-1.68,3.28-3.39,4.75-5.15A14,14,0,0,1,704.8,596,8.47,8.47,0,0,1,701.44,599.4Z"
          fill="#dbc3a1"
        />
        <path
          d="M696.59,538.5c-2.28-1.67-5.17-1.92-7.9-1.93a36.52,36.52,0,0,0-9.39.79,17.6,17.6,0,0,0-7.27,3.95,8.22,8.22,0,0,0-2.41,3.27c-.52,1.46-.71,3-1.29,4.45a17.52,17.52,0,0,1-2.5,4.26,19.4,19.4,0,0,0-2.39,3.37c-1.41,2.87-.14,6.09-.83,9.11a11.21,11.21,0,0,1-2,4.14,14.7,14.7,0,0,0-2.22,3.41,8.4,8.4,0,0,0,0,4.53,16.43,16.43,0,0,1,.18,4.85c-.41,3.59-1.78,7-2.85,10.39-.49,1.55-1.15,3.29-.92,4.95s1.67,2.71,1.55,4.28c0,.32.48.32.5,0,.1-1.27-.75-2.23-1.25-3.32-.69-1.51-.17-3.18.27-4.69.87-3,2-5.88,2.73-8.91a21.64,21.64,0,0,0,.58-4.24,25.42,25.42,0,0,0-.5-4.51,6,6,0,0,1,.9-4.59c.75-1.12,1.67-2.1,2.33-3.28a11.12,11.12,0,0,0,1.3-4,31.86,31.86,0,0,0-.07-4.58,7.29,7.29,0,0,1,1.26-4.32c.8-1.21,1.8-2.27,2.61-3.47a17.39,17.39,0,0,0,1.92-3.74c.51-1.4.64-2.95,1.24-4.31a9.4,9.4,0,0,1,2.92-3.35,17,17,0,0,1,3.62-2.22c3.3-1.49,6.89-1.65,10.46-1.7,3.1,0,6.47-.07,9.08,1.85.26.19.51-.24.26-.43Z"
          fill="#e8ceaf"
        />
        <path
          d="M703.27,544.89c6.61,5.86,13,13.51,11.87,23A46,46,0,0,1,711.78,580a54.85,54.85,0,0,1-5.86,10.64,54.06,54.06,0,0,1-9.28,10.13c-.24.2.11.56.36.35a54.9,54.9,0,0,0,14.77-19.82,52,52,0,0,0,3.67-12,20.22,20.22,0,0,0,.06-6.81,22.43,22.43,0,0,0-2.12-6.27c-2.32-4.58-6-8.32-9.76-11.7-.24-.21-.59.14-.35.36Z"
          fill="#e8ceaf"
        />
        <path
          d="M697.36,544.28a6.57,6.57,0,0,1-3.94.6,11.89,11.89,0,0,0-3.71.31,25,25,0,0,0-7.15,3.5c-4,2.71-8,6.5-9.44,11.25a12.12,12.12,0,0,0-.55,3.64,22.64,22.64,0,0,1-.1,4.51c-.48,2.4-2.35,4.16-3.24,6.38-1.06,2.64-.12,5.54-.33,8.29A51,51,0,0,1,667,591.3c-1.19,4.68-1.82,10.56,2,14.25.23.23.58-.13.35-.35-3.45-3.34-3.09-8.68-2.06-13,.64-2.68,1.51-5.3,1.91-8a17.86,17.86,0,0,0,.17-4,17,17,0,0,1-.06-4.34c.43-2.35,2.24-4.08,3.16-6.22,1.09-2.51.3-5.2.69-7.82.76-5,4.65-9.07,8.56-12a26.1,26.1,0,0,1,7.88-4.14,13.29,13.29,0,0,1,4.31-.33,6.26,6.26,0,0,0,3.67-.68c.28-.17,0-.61-.25-.44Z"
          fill="#e8ceaf"
        />
        <path
          d="M703.87,539.91a4.38,4.38,0,0,1,3.09.66,5.79,5.79,0,0,1,1.88,2.54,3.49,3.49,0,0,0,1.8,1.71,5.25,5.25,0,0,1,1.39.72,2.79,2.79,0,0,1,.74,1.47,9.18,9.18,0,0,0,1.07,2.82c.56.89,1.23,1.71,1.79,2.6a17.36,17.36,0,0,1,2.41,6.64c0,.32.52.19.48-.13a17.82,17.82,0,0,0-1.71-5.43c-.87-1.71-2.24-3.11-3-4.84-.68-1.46-.48-3.15-2.13-4a4.23,4.23,0,0,1-2.19-1.51,15.75,15.75,0,0,0-1.19-2.12,4.89,4.89,0,0,0-4.54-1.65c-.31.05-.18.53.14.48Z"
          fill="#e8ceaf"
        />
        <path
          d="M674.12,585.18a9.24,9.24,0,0,0-1.25,4.22,8.65,8.65,0,0,0,.17,2.21,19.71,19.71,0,0,1,.61,2.74c.1,1.73-.41,3.38,0,5.1a15.58,15.58,0,0,0,2.14,4.3c.17.27.61,0,.43-.26a15.25,15.25,0,0,1-2.09-4.17c-.43-1.67.06-3.29,0-5-.06-1.52-.78-2.9-.79-4.44a8.72,8.72,0,0,1,1.19-4.48.25.25,0,0,0-.43-.25Z"
          fill="#e8ceaf"
        />
        <path
          d="M160.52,375.44c.28-.75-.1-1.1-1.3-1.28a8.74,8.74,0,0,0-3.6.4c-2.34.8-3.35,2.94-2.7,2.53a10.05,10.05,0,0,1,4.45-1.43C158.7,375.46,160.33,376,160.52,375.44Z"
          fill="#a32b28"
        />
        <path
          d="M169.37,375.38c-.26-.74.09-1.1,1.21-1.31a7.94,7.94,0,0,1,3.37.31c1.79.56,2.77,2.65,2.29,2.37a8.52,8.52,0,0,0-3.93-1.23C171.06,375.35,169.54,375.89,169.37,375.38Z"
          fill="#a32b28"
        />
        <g>
          <path
            d="M167.58,397.3s1.42,3.12-2.58,3-7.75-4.69-7.75-4.69Z"
            fill="#9c5844"
          />
          <path
            d="M167.58,397.3s1.66-3.33-3.4-2.18a28,28,0,0,1-6.93.46S163.9,398.11,167.58,397.3Z"
            fill="#9c5844"
          />
        </g>
        <path
          d="M165.36,390.28h0c1-.07,3.11-.59,3.74-1.52a1,1,0,0,0,.15-.87c-.33-1-2.1-7.22-2.12-7.28a.36.36,0,0,0-.44-.25.37.37,0,0,0-.25.45c.07.25,1.79,6.27,2.12,7.3a.26.26,0,0,1-.05.25c-.39.57-2.07,1.13-3.21,1.21a.36.36,0,0,0-.33.38A.35.35,0,0,0,165.36,390.28Z"
          fill="#9c5844"
        />
        <circle cx={171} cy={381.5} r={1.5} fill="#26211d" />
        <path
          d="M154.92,383.72h0a2.74,2.74,0,0,1,2-1.55,2.92,2.92,0,0,1,2.4.3c.33.24.59-.33.26-.57a3.51,3.51,0,0,0-2.85-.37,3.25,3.25,0,0,0-2.37,1.85c-.15.38.38.72.52.34"
          fill="#26211d"
        />
        <path
          d="M729.54,656.06s-37.75,15.69-66.48,15.29a9.21,9.21,0,0,0-1.74.13,30,30,0,0,1-8.82-.12"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M730.5,666.06S692.76,681.75,664,681.35a9.27,9.27,0,0,0-1.74.13,30,30,0,0,1-8.82-.12"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M615.25,613.29s-13.88,12.81-13.06,26"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M622,618.5s-10,7.79-12,24"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M719.75,582.34s5.65,6.76,22,9"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M717.07,589.86s10.56,9.91,22.75,8.77"
          fill="none"
          stroke="#ededed"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M647.17,672.9s20.42,39.3,15.38,71.2h0l17,4.9,6.25-42.09-17-18.2-15.24-6.41-6.29-9.4"
          fill="#13a89e"
        />
      </g>
      <g id="light">
        <polygon
          points="305.89 3 1465.5 1055 1111.83 1055 982.64 1055 454.46 1054.02 305.89 3"
          opacity={0.15}
          fill="url(#linear-gradient)"
        />
      </g>
    </g>
  </svg>
  </StyledBackgroundWrapper>
)

export default SvgConsentIntro
